export default {
  "nav_signin": "Inloggen",
  "nav_account": "Account",
  "nav_signout": "Uitloggen",
  "hero_title": "Slimme Digitale Oplossingen",
  "hero_title_line1": "Infinity Business — Slimme",
  "hero_title_line2": "Digitale Oplossingen",
  "hero_subtitle": "Maak kennis met RisTA, uw digitale partner",
  "hero_cta": "Praat met RisTA",
  "hero_cta2": "Bekijk diensten",
  "b2b_title": "Zakelijke Oplossingen (B2B)",
  "p2p_title": "Persoonlijke Oplossingen (P2P)",
  "b2b_desc": "Web, mobiel, software, hosting, design en advertenties",
  "p2p_desc": "Crypto-educatie, investeringstools, organisatie, vertaling, branding, domeinen",
  "services_title": "Onze Diensten",
  "services_subtitle": "Van zakelijke weboplossingen tot persoonlijke investeringstools. RisTA begeleidt u.",
  "cta_title": "Klaar om iets geweldigs te bouwen?",
  "cta_subtitle": "Praat met RisTA voor een persoonlijke offerte in minuten.",
  "about": "Over ons",
  "contact": "Contact",
  "privacy": "Privacy",
  "blog": "Blog",
  "donate": "Doneren",
  "booking": "Sessie boeken",
  "login_title": "Welkom terug",
  "register_title": "Account aanmaken",
  "login_subtitle": "Log in op uw Infinity Business account",
  "register_subtitle": "Word vandaag lid van Infinity Business",
  "auth0_btn": "Doorgaan met Auth0",
  "or_email": "of doorgaan met email",
  "email": "E-mailadres",
  "password": "Wachtwoord",
  "full_name": "Volledige naam",
  "signin_btn": "Inloggen",
  "register_btn": "Account aanmaken",
  "no_account": "Geen account?",
  "have_account": "Al een account?",
  "create_one": "Aanmaken",
  "sign_in": "Inloggen",
  "pricing_title": "Kies uw abonnement",
  "pricing_subtitle": "Alle abonnementen bevatten toegang tot RisTA.",
  "pay_stripe": "Betalen met Stripe",
  "pay_mypos": "Betalen met myPOS",
  "pay_crypto": "Betalen met Crypto",
  "free_plan": "Huidig gratis abonnement",
  "most_popular": "Meest populair",
  "dashboard_title": "Mijn account",
  "profile": "Profiel",
  "security": "Beveiliging (2FA)",
  "subscription": "Abonnement",
  "upgrade": "Upgraden",
  "change_plan": "Abonnement wijzigen",
  "twofa_title": "Tweefactorauthenticatie",
  "setup_2fa": "2FA instellen",
  "disable_2fa": "2FA uitschakelen",
  "payment_success": "Betaling geslaagd!",
  "payment_cancel": "Betaling geannuleerd",
  "footer_copyright": "© 2026 Liber Nostra d.o.o. Alle rechten voorbehouden.",
  "about_title": "Over Infinity Business",
  "contact_title": "Neem contact op",
  "privacy_title": "Privacybeleid",
  "send_message": "Bericht versturen",
  "trade_title": "Wij handelen voor u",
  "trade_desc": "Professionele crypto-handelsdiensten. Chat met ons.",
  "back_home": "Terug naar home",
  "loading": "Laden...",
  "save": "Opslaan",
  "session_expired": "Uw sessie is verlopen. Log opnieuw in.",
  "nav_services": "Diensten",
  "nav_portal": "Portaal",
  "nav_credits": "Tegoed",
  "hero_online": "Online",
  "hero_digital_partner": "Digitale partner",
  "business_solutions": "Zakelijke oplossingen",
  "personal_solutions": "Persoonlijke oplossingen",
  "enterprise_desc": "Professionele digitale diensten voor bedrijfsgroei.",
  "personal_desc": "Slimme investeringstools en educatie voor persoonlijke groei.",
  "services_hero_title": "Onze diensten",
  "services_hero_desc": "Van basis websites tot geavanceerde intelligente oplossingen. Wij leveren digitale excellentie.",
  "get_started": "Aan de slag",
  "get_a_quote": "Offerte aanvragen",
  "free_seo_audit": "Gratis SEO-audit",
  "ready_to_start": "Klaar om te starten?",
  "ready_to_build": "Klaar om iets geweldigs te bouwen?",
  "ready_to_build_sub": "Praat met RisTA voor een persoonlijke offerte.",
  "trusted_worldwide": "Wereldwijd vertrouwd",
  "chat_placeholder": "Typ je bericht...",
  "chat_suggested_1": "Ik heb een website nodig",
  "chat_suggested_2": "Vertel me over de diensten",
  "chat_suggested_3": "Ik wil een slimme dienst",
  "chat_suggested_4": "Offerte aanvragen",
  "trust_platform": "Betrouwbaar platform",
  "trust_security": "Bedrijfsbeveiliging",
  "trust_ai": "Slimme Technologie",
  "trust_global": "Wereldwijd bereik",
  "back_to_home": "Terug naar home",
  "continue_google": "Doorgaan met Google",
  "continue_facebook": "Doorgaan met Facebook",
  "continue_github": "Doorgaan met GitHub",
  "or_continue_email": "of doorgaan met email",
  "two_factor_auth": "Tweefactorauthenticatie",
  "enter_2fa_code": "Voer de code van uw authenticator-app in",
  "verify_btn": "Code verifiëren",
  "verifying": "Verifiëren...",
  "use_different_account": "Ander account gebruiken",
  "session_expired_msg": "Uw sessie is verlopen wegens inactiviteit.",
  "nav_home": "Home",
  "nav_back": "Terug",
  "my_account": "Mijn account",
  "sign_out": "Uitloggen",
  "client_portal": "Klantenportaal",
  "your_projects": "Uw projecten",
  "your_invoices": "Uw facturen",
  "projects": "Projecten",
  "invoices_tab": "Facturen",
  "milestones": "Mijlpalen",
  "messages": "Berichten",
  "no_projects": "Nog geen projecten.",
  "no_invoices": "Nog geen facturen.",
  "no_messages": "Nog geen berichten.",
  "type_message": "Typ een bericht...",
  "back_to_projects": "Terug naar projecten",
  "budget_label": "Budget",
  "progress_label": "Voortgang",
  "service_label": "Dienst",
  "portal_locked_desc": "Het portaal is beschikbaar voor goedgekeurde klanten.",
  "contact_to_start": "Neem contact op",
  "quick_web_dev": "Webontwikkeling",
  "quick_mobile": "Mobiele app",
  "quick_crypto": "Crypto-educatie",
  "quick_get_quote": "Offerte aanvragen",
  "quick_tell_more": "Vertel me meer",
  "quick_have_project": "Ik heb een project",
  "quick_submit": "Verzoek indienen",
  "get_cost_estimate": "Kostenraming",
  "choose_plan": "Kies uw plan",
  "choose_plan_desc": "Schaal uw bedrijf met het juiste plan.",
  "current_free_plan": "Huidig gratis plan",
  "svc_ecommerce_label": "E-Commerce / Webwinkel",
  "svc_ecommerce_desc": "Complete webwinkels met betaalintegratie",
  "svc_ecommerce_price": "Vanaf €799",
  "svc_seo_label": "SEO & Digitale Marketing",
  "svc_seo_desc": "Zoekmachineoptimalisatie en groeistrategie",
  "svc_seo_price": "Vanaf €299/maand",
  "svc_hosting_label": "Managed Hosting",
  "svc_hosting_desc": "Veilige, snelle en betrouwbare hosting-infrastructuur",
  "svc_hosting_price": "Vanaf €29/maand",
  "svc_advertising_label": "Digitale Reclame",
  "svc_advertising_desc": "PPC, social ads en performance marketing",
  "svc_advertising_price": "Vanaf €499/maand",
  "svc_trading_label": "Handelsconsultatie",
  "svc_trading_desc": "Door experts begeleide handelsstrategie-sessies",
  "svc_trading_price": "Vanaf €149/sessie",
  "svc_domains_label": "Domeinbeheer",
  "svc_domains_desc": "Domeinregistratie, DNS-beheer en transfers",
  "svc_domains_price": "Vanaf €19/jaar",
  "testimonials_title": "Wat onze klanten zeggen",
  "testimonials_subtitle": "Vertrouwd door bedrijven in heel Europa",
  "stat_projects": "Projecten opgeleverd",
  "stat_satisfaction": "Klanttevredenheid",
  "stat_languages": "Ondersteunde talen",
  "all_rights_reserved": "Alle rechten voorbehouden.",
  "form_your_name": "Uw naam",
  "form_your_email": "Uw e-mail",
  "form_describe_need": "Beschrijf wat u nodig heeft...",
  "form_additional_feedback": "Extra feedback? (optioneel)",
  "form_email_followup": "Uw e-mail (optioneel, voor opvolging)",
  "form_budget_range": "Budgetbereik",
  "form_timeline": "Tijdlijn",
  "form_cancel": "Annuleren",
  "form_select_services": "Selecteer diensten (meerdere mogelijk):",
  "rating_title": "Beoordeel uw ervaring met RisTA",
  "rating_helpful": "Hoe nuttig was dit gesprek?",
  "rating_overall": "Algehele assistentervaring",
  "rating_recommend": "Zou u RisTA aanbevelen?",
  "rating_yes": "Ja",
  "rating_no": "Nee",
  "rating_submit": "Beoordeling indienen",
  "rating_skip": "Overslaan",
  "rating_thanks": "Bedankt voor uw feedback!",
  "generating_estimate": "Kostenraming genereren...",
  "profile_info": "Profielinformatie",
  "profile_name": "Naam",
  "profile_email": "E-mail",
  "profile_role": "Rol",
  "profile_member_since": "Lid sinds",
  "profile_rerun_onboarding": "Introductie opnieuw starten",
  "profile_language_pref": "Voorkeurstaal",
  "profile_language_saved": "Taalvoorkeur opgeslagen!",
  "privacy_heading": "Privacybeleid",
  "terms_heading": "Algemene voorwaarden",
  "about_heading": "Over Infinity Business",
  "walkthrough_heading": "Handleidingen",
  "services_cta_title": "Klaar om te beginnen?",
  "services_talk_rista": "Praat met RisTA",
  "nav_tools": "Tools",
  "nav_marketplace": "Marktplaats",
  "chat_digital_partner": "Digitale partner",
  "chat_online": "Online",
  "chat_help_text": "Ik kan helpen met webontwikkeling, mobiele apps, design, crypto en meer.",
  "chat_your_partner": "Uw digitale partner",
  "chat_assistant_subtitle": "Chat met uw slimme assistent",
  "tab_password": "Wachtwoord",
  "tab_rista_services": "RisTA Diensten",
  "tab_analytics": "Analyses",
  "tab_projects": "Projecten",
  "tab_referral": "Verwijzingsprogramma",
  "marketplace_title": "Template Marktplaats",
  "marketplace_subtitle": "Premium sjablonen die u kunt aanpassen. Professionele kwaliteit, klaar voor gebruik.",
  "marketplace_search": "Sjablonen zoeken...",
  "marketplace_purchase": "Kopen",
  "marketplace_preview": "Voorbeeld",
  "marketplace_all": "Alle",
  "marketplace_category_website": "Website",
  "marketplace_category_brand": "Merk",
  "marketplace_category_resume": "CV",
  "marketplace_downloads": "downloads",
  "marketplace_features": "Functies",
  "case_studies_title": "Succesverhalen van klanten",
  "case_studies_subtitle": "Echte resultaten van echte bedrijven. Bekijk de transformatie.",
  "case_studies_before": "Voor",
  "case_studies_after": "Na",
  "case_studies_cta_title": "Klaar om uw bedrijf te laten groeien?",
  "case_studies_cta_desc": "Sluit u aan bij deze bedrijven en behaal vergelijkbare resultaten met onze slimme diensten.",
  "case_studies_cta_btn": "Beginnen",
  "profile_go_homepage": "Ga naar homepage",
  "onboarding_welcome_title": "Welkom bij Infinity Business",
  "onboarding_welcome_subtitle": "Uw slimme digitale partner",
  "onboarding_welcome_content": "Infinity Business biedt uitgebreide B2B en P2P digitale diensten. Onze slimme assistent RisTA begeleidt u.",
  "onboarding_welcome_item1": "Slimme projectschattingen",
  "onboarding_welcome_item2": "Web-, mobiele en designdiensten",
  "onboarding_welcome_item3": "Crypto-educatie en investeringstools",
  "onboarding_welcome_item4": "Gepersonaliseerde consultaties",
  "onboarding_next": "Volgende",
  "onboarding_get_started": "Beginnen",
  "onboarding_back": "Terug",
  "onboarding_biz_title": "Dienstselectie",
  "onboarding_biz_subtitle": "Wat beschrijft uw behoeften het best?",
  "onboarding_biz_content": "Help ons de juiste diensten voor u aan te bevelen:",
  "onboarding_biz_type_startup": "Startup / Nieuw bedrijf",
  "onboarding_biz_type_smb": "Klein-Middelbedrijf",
  "onboarding_biz_type_enterprise": "Groot bedrijf / Onderneming",
  "onboarding_biz_type_freelancer": "Freelancer / Individu",
  "onboarding_biz_type_investor": "Investeerder / Crypto-enthousiasteling",
  "change_password_title": "Wachtwoord wijzigen",
  "referral_title": "Verwijzingsprogramma",
  "referral_generate": "Genereer mijn verwijzingscode",
  "referral_redeem_title": "Code inwisselen",
  "referral_redeem_btn": "Inwisselen",
  "referral_referrals": "Verwijzingen",
  "referral_rewards": "Beloningen",
  "referral_copy_link": "Link kopiëren",
  "referral_copied": "Gekopieerd!",
  "project_tracker_title": "Projecttracking",
  "analytics_total_services": "Totale diensten",
  "analytics_completed": "Voltooid",
  "analytics_pending": "In afwachting",
  "analytics_total_spent": "Totaal besteed",
  "analytics_credit_balance": "Creditsaldo",
  "analytics_recent": "Recente diensten",
  "nav_try_free": "Gratis proberen",
  "testimonial_1_text": "RisTA hielp ons onze volledige webpresentie in slechts 2 weken op te bouwen.",
  "testimonial_2_text": "Het merkpakket en de social media kalender bespaarden ons maanden werk.",
  "testimonial_3_text": "Ik gebruik regelmatig de CV-maker en analysetools. De kwaliteit is uitstekend.",
  "services_cta_desc": "Praat met RisTA, onze intelligente digitale assistent, voor een gepersonaliseerde offerte.",
  "services_free_audit": "Gratis SEO Audit",
  "tools_title": "Gratis marketingtools",
  "tools_subtitle": "Probeer onze gratis tools - geen registratie nodig",
  "sp_basic_web_name": "Basis website creatie",
  "sp_basic_web_desc": "Professionele website voor uw bedrijf met modern design en volledige mobiele compatibiliteit.",
  "sp_basic_web_feat": "Modern responsief design|Tot 5 pagina's|Contactformulier integratie|Mobiel geoptimaliseerd|Basis SEO setup|Hulp bij content invoer",
  "sp_web_store_name": "Webwinkel / E-Commerce",
  "sp_web_store_desc": "Volledig uitgeruste e-commerce platform met geintegreerde betalingen en marketingtools.",
  "sp_web_store_feat": "Complete online winkel|Betalingsverwerking|Productbeheer|Ordertracking|SEO optimalisatie|Marketingstrategie inbegrepen",
  "sp_custom_web_name": "Aangepaste webapplicatie",
  "sp_custom_web_desc": "Op maat gemaakte webapplicaties volgens uw exacte bedrijfsvereisten.",
  "sp_custom_web_feat": "Aangepast softwareontwerp|API integraties|Database architectuur|Schaalbare infrastructuur|Admin dashboards|Doorlopende ondersteuning",
  "sp_mobile_app_name": "Mobiele applicatie",
  "sp_mobile_app_desc": "Native en cross-platform mobiele applicaties voor iOS en Android.",
  "sp_mobile_app_feat": "iOS & Android|Cross-platform ontwikkeling|Push notificaties|App store indiening|UI/UX design|Backend integratie",
  "sp_seo_name": "SEO & Digitale Marketing",
  "sp_seo_desc": "Verhoog uw online zichtbaarheid met uitgebreide SEO- en digitale marketingstrategieen.",
  "sp_seo_feat": "Volledige SEO audit|Zoekwoord optimalisatie|Content strategie|Google Ads beheer|Social media marketing|Maandelijkse rapporten",
  "sp_graphic_name": "Grafisch ontwerp & Branding",
  "sp_graphic_desc": "Complete branding en grafisch ontwerp oplossingen voor uw bedrijfsidentiteit.",
  "sp_graphic_feat": "Logo ontwerp|Merkidentiteit|Marketingmaterialen|Social media graphics|Print ontwerp|Stijlgids",
  "sp_crypto_edu_name": "Crypto educatie programma",
  "sp_crypto_edu_desc": "Leer cryptocurrency handel en blockchain technologie van branche-experts.",
  "sp_crypto_edu_feat": "Blockchain basiskennis|Handelsstrategieen|Wallet beveiliging|DeFi introductie|Marktanalyse|Persoonlijke mentoring",
  "sp_invest_name": "Slimme investerings tools",
  "sp_invest_desc": "Professionele investerings tracking en analyse tools aangedreven door slimme technologie.",
  "sp_invest_feat": "Portfolio tracker|Markt dashboard|Slimme inzichten|Risicobeoordeling|Realtime meldingen|Multi-exchange ondersteuning",
  "sp_ad_name": "Advertentiediensten",
  "sp_ad_desc": "Bereik miljoenen via ons uitgebreide portaalnetwerk in meerdere regio's.",
  "sp_ad_feat": "20+ portaal netwerk|10M+ bereik|Gerichte campagnes|Prestatie tracking|Multi-platform advertenties|ROI optimalisatie",
  "contact_heading": "Neem contact op",
  "contact_subtitle_text": "Heeft u een vraag of wilt u een project bespreken? We horen graag van u.",
  "contact_name_label": "Naam",
  "contact_email_label": "E-mail",
  "contact_subject_label": "Onderwerp",
  "contact_message_label": "Bericht",
  "contact_name_ph": "Uw naam",
  "contact_email_ph": "u@voorbeeld.com",
  "contact_subject_ph": "Waar gaat het over?",
  "contact_message_ph": "Vertel ons over uw project of vraag...",
  "contact_send_btn": "Bericht verzenden",
  "contact_sending": "Verzenden...",
  "contact_sent_title": "Bericht verzonden!",
  "contact_sent_msg": "Bedankt voor uw bericht. We nemen binnen 24 uur contact op.",
  "contact_send_another": "Nog een bericht verzenden",
  "contact_info_email": "E-mail",
  "contact_info_location": "Locatie",
  "contact_info_eu": "Europese Unie",
  "contact_info_response": "Reactietijd",
  "contact_info_response_time": "Binnen 24 uur",
  "contact_info_hours": "Ma - Vr, 9:00 - 18:00 CET",
  "tf_seo_name": "Gratis SEO audit",
  "tf_seo_desc": "Krijg een uitgebreide SEO analyse van elke website - geen registratie nodig.",
  "tf_color_name": "Kleurenpalet generator",
  "tf_color_desc": "Genereer mooie, harmonieuze kleurenpaletten voor uw merk.",
  "tf_headline_name": "Kop analyzer",
  "tf_headline_desc": "Beoordeel uw koppen op klikpotentieel en emotionele impact.",
  "tf_chat_name": "Chat met RisTA",
  "tf_chat_desc": "Krijg directe projectschattingen en verken diensten in 11 talen.",
  "tf_free_label": "Gratis",
  "tools_seo_title": "Snelle SEO check",
  "tools_seo_desc": "Directe SEO score voor elke website",
  "tools_seo_ph": "Voer website URL in (bijv. voorbeeld.com)",
  "tools_analyze": "Analyseren",
  "tools_color_title": "Kleurenpalet generator",
  "tools_color_desc": "Genereer complementaire kleurenpaletten",
  "tools_headline_title": "Kop analyzer",
  "tools_headline_desc": "Analyseer de effectiviteit van koppen",
  "tools_headline_ph": "Voer uw kop in...",
  "tools_headline_btn": "Kop analyseren",
  "tools_issues": "Gevonden problemen",
  "tools_suggestions": "Suggesties",
  "tools_score": "Score",
  "docs_heading": "Platform functies",
  "docs_subtitle": "Alles wat Infinity Business biedt voor uw digitale reis.",
  "docs_no_data": "Geen documentatie beschikbaar.",
  "tester_heading": "Word tester",
  "tester_subtitle": "Help ons het platform te verbeteren en krijg gratis toegang tot diensten.",
  "tester_req_title": "Wat is vereist",
  "tester_benefit_title": "Wat u krijgt",
  "tester_apply_title": "Aanmelden",
  "tester_submit_app": "Aanmelding indienen",
  "tester_applied_title": "Aanmelding ingediend",
  "tester_applied_msg": "Onze admin zal uw aanmelding beoordelen en u wordt op de hoogte gesteld.",
  "tester_need_account": "U heeft een account nodig om u aan te melden.",
  "tester_dash_title": "Tester dashboard",
  "tester_weekly_logins": "Wekelijkse aanmeldingen",
  "tester_weekly_reports": "Wekelijkse rapporten",
  "tester_target_met": "Doel bereikt!",
  "tester_total_reports": "Totaal ingediende rapporten",
  "tester_on_track": "Op koers",
  "tester_at_risk": "Risico",
  "tester_report_heading": "Bug / feedback rapport indienen",
  "tester_submit_report": "Rapport indienen",
  "seo_page_title": "Gratis SEO audit",
  "seo_page_btn": "Audit uitvoeren",
  "seo_page_running": "Analyseren...",
  "referral_reward_title": "Hoe beloningen werken",
  "referral_reward_desc": "Verdien 10% van elke aankoop door gebruikers die u verwijst, automatisch bijgeschreven als gratis credits.",
  "referral_reward_1": "Deel uw unieke verwijzingslink met vrienden",
  "referral_reward_2": "Wanneer zij een aankoop doen, verdient u 10% als gratis credits",
  "referral_reward_3": "Credits worden automatisch aan uw saldo toegevoegd",
  "referral_earned_label": "Verdiende credits",
  "profile_picture": "Profielfoto",
  "profile_bio": "Biografie",
  "profile_website": "Website",
  "profile_interests": "Interesses",
  "profile_upload_photo": "Foto uploaden",
  "profile_save": "Profiel opslaan",
  "admin_notes": "Admin notities",
  "admin_notes_add": "Notitie toevoegen",
  "sub_most_popular": "Meest populair",
  "sub_free": "Gratis",
  "sub_one_time": "eenmalig",
  "sub_team_members": "Teamleden",
  "sub_members_info": "Nodig teamleden uit om uw plan te delen. Elk lid krijgt een eigen login en toegang tot diensten onder uw abonnement.",
  "sub_show_less": "Minder tonen",
  "sub_more_features": "meer functies",
  "sub_pay_with": "Betaal met",
  "sub_preferred": "voorkeur",
  "sub_live_crypto": "Live cryptoprijzen (EUR & USD)",
  "sp_logo_name": "Logo Ontwerp",
  "sp_logo_desc": "Professioneel logo-ontwerp dat de essentie van uw merk vastlegt.",
  "sp_logo_feat": "3 unieke concepten|Onbeperkte revisies|Vectorbestanden|Kleur + Z/W|Merkrichtlijnen|Social media kit",
  "sp_brand_name": "Volledige Merkidentiteit",
  "sp_brand_desc": "Compleet merkidentiteitspakket met logo, kleurenpalet en richtlijnen.",
  "sp_brand_feat": "Logo|Kleurenpalet|Typografie|Visitekaartje|Briefpapier|PDF richtlijnen|Social templates",
  "sp_poster_name": "Poster Ontwerp",
  "sp_poster_desc": "Opvallende posterontwerpen voor evenementen en campagnes.",
  "sp_poster_feat": "Aangepaste illustratie|Drukklare bestanden|Meerdere formaten|2 revisierondes|Hoge resolutie|Digitaal + print",
  "sp_flyer_name": "Flyer Ontwerp",
  "sp_flyer_desc": "Professionele flyer-ontwerpen voor marketing en evenementen.",
  "sp_flyer_feat": "Voor- & achterzijde|Drukklare PDF|Digitale versie|QR-code|2 revisies|Meerdere formaten",
  "sp_menu_name": "Menu Ontwerp",
  "sp_menu_desc": "Prachtige menu-ontwerpen voor restaurants en cafés.",
  "sp_menu_feat": "Aangepaste layout|Foto-integratie|QR-versie|Drukklare bestanden|Seizoensupdate|Meerdere pagina's",
  "currency_label": "Valuta",
  "currency_eur": "EUR",
  "currency_usd": "USD",
  "currency_cny": "CNY",
  "about_intro": "Wij zijn een technologiebedrijf gericht op intelligente digitale oplossingen. Opgericht in 2026, combineert Infinity Business slimme innovatie met bewezen expertise.",
  "about_values": "Onze Waarden",
  "about_what_we_do": "Wat We Doen",
  "about_meet_rista": "Maak Kennis met RisTA",
  "about_rista_desc": "RisTA is onze intelligente assistent. Helpt bij het kwalificeren van vereisten, biedt directe begeleiding en verbindt u met ons team. 24/7 beschikbaar, meertalig.",
  "about_talk_rista": "Praat met RisTA",
  "about_val_trust": "Vertrouwen en Veiligheid",
  "about_val_trust_desc": "We hanteren de hoogste standaarden voor gegevensbescherming.",
  "about_val_innovation": "Innovatie",
  "about_val_innovation_desc": "Geavanceerde slimme technologie drijft onze oplossingen aan.",
  "about_val_partnership": "Partnerschap",
  "about_val_partnership_desc": "We werken naast u als een echte partner.",
  "about_val_global": "Wereldwijd Bereik",
  "about_val_global_desc": "Onze oplossingen zijn ontworpen voor internationale markten.",
  "about_svc_web": "Webontwikkeling",
  "about_svc_web_desc": "Full-stack webapplicaties, e-commerce platformen en CMS-oplossingen.",
  "about_svc_mobile": "Mobiele Applicaties",
  "about_svc_mobile_desc": "Native en cross-platform apps voor iOS en Android.",
  "about_svc_software": "Maatwerksoftware",
  "about_svc_software_desc": "Op maat gemaakte softwareoplossingen voor procesautomatisering.",
  "about_svc_invest": "Slimme Investeringen",
  "about_svc_invest_desc": "Slimme crypto- en DeFi-tools met professionele handelsservice.",
  "micro_tools_title": "Slimme Micro-tools",
  "micro_tools_subtitle": "Directe slimme inzichten voor leadgeneratie en strategische planning.",
  "micro_tools_all": "Alle",
  "micro_tools_try": "Probeer",
  "micro_tools_generate_free": "Genereer (Gratis)",
  "micro_tools_generate_paid": "Genereer",
  "micro_tools_close": "Sluiten",
  "micro_tools_interested": "Geïnteresseerd?",
  "tools_view_service": "Bekijk dienst",
  "tools_talk_rista": "Praat met RisTA",
  "competitor_title": "Slimme Concurrentie-analyse",
  "competitor_desc": "Voer een concurrent-URL in voor slimme analyse met SEO-vergelijking en designbeoordeling.",
  "competitor_url_ph": "Voer concurrent-URL in",
  "competitor_analyze": "Analyseer concurrent",
  "competitor_score": "Totaalscore",
  "competitor_seo": "SEO Analyse",
  "competitor_design": "Design Analyse",
  "competitor_content": "Inhoudsanalyse",
  "competitor_strengths": "Sterktes",
  "competitor_weaknesses": "Zwaktes",
  "competitor_opportunities": "Kansen",
  "competitor_recommendations": "Aanbevelingen",
  "accessibility_title": "Toegankelijkheidscheck",
  "accessibility_desc": "Controleer toegankelijkheidsnormen",
  "cat_lead_gen": "Lead-Gen & Verkeer",
  "cat_discovery": "Rapportage",
  "cat_email": "E-mail & Workflow",
  "cat_planning": "Planning & Strategie",
  "cat_content": "Content & Positionering",
  "sp_tools_title": "Slimme Microdiensten",
  "sp_tools_desc": "Directe slimme diensten voor content, branding, analyse en documenten.",
  "sp_free_title": "Gratis Tools",
  "sp_free_desc": "Probeer ons platform met deze gratis tools.",
  "a11y_checker": "Toegankelijkheidscontrole",
  "a11y_rescan": "Opnieuw scannen",
  "a11y_scanning": "WCAG-audit uitvoeren...",
  "a11y_compliant": "Conform",
  "a11y_passed": "geslaagd",
  "a11y_violations": "overtredingen",
  "a11y_incomplete": "moet worden beoordeeld",
  "a11y_issues_found": "Problemen gevonden",
  "a11y_no_issues": "Geen toegankelijkheidsproblemen gevonden!",
  "a11y_disclaimer": "Automatische controles dekken ~30% van de problemen. Handmatige tests met schermlezers worden aanbevolen.",
  "a11y_error": "Audit mislukt. Probeer het opnieuw.",
  "admin_ratings": "Beoordelingen en feedback",
  "admin_timeline": "Projecttijdlijn",
  "admin_add_milestone": "Mijlpaal toevoegen",
  "admin_milestone_title": "Mijlpaaltitel",
  "admin_milestone_desc": "Beschrijving (optioneel)",
  "admin_no_milestones": "Nog geen mijlpalen. Voeg de eerste toe!",
  "admin_email_templates_desc": "Pas e-mailsjablonen aan met de visuele blokeditor.",
  "admin_preloader": "Preloader-configuratie",
  "admin_image_gen": "Afbeeldingsgeneratie",
  "admin_health_score": "Gezondheidsscore",
  "nav_health_score": "Gezondheidsscore",
  "admin_new": "nieuw",
  "admin_score": "Score",
  "admin_avg_rating": "Gem. beoordeling",
  "admin_avg_exp": "Gem. ervaring",
  "admin_reviews": "beoordelingen",
  "admin_out_of": "Van",
  "admin_total": "Totaal",
  "admin_unread": "Ongelezen",
  "admin_active": "Actief",
  "admin_pending": "In behandeling",
  "admin_save": "Opslaan",
  "admin_cancel": "Annuleren",
  "admin_delete": "Verwijderen",
  "admin_edit": "Bewerken",
  "admin_status": "Status",
  "admin_actions": "Acties",
  "admin_created": "Aangemaakt",
  "admin_updated": "Bijgewerkt",
  "admin_view_all": "Alles bekijken",
  "admin_no_data": "Geen gegevens beschikbaar",
  "status_planned": "Gepland",
  "status_in_progress": "In uitvoering",
  "status_completed": "Voltooid",
  "status_blocked": "Geblokkeerd",
  "priority_low": "Laag",
  "priority_medium": "Gemiddeld",
  "priority_high": "Hoog",
  "priority_critical": "Kritiek",
  "analytics_subscription": "Abonnement",
  "developer_title": "Ontwikkelaar-API",
  "developer_subtitle": "Integreer onze intelligente diensten in uw applicaties",
  "estimate_accept": "Accepteren en verzenden",
  "estimate_revise": "Herzien",
  "estimate_title": "Projectkostenschatting",
  "estimate_service": "Dienst",
  "estimate_complexity": "Complexiteit",
  "estimate_base_price": "Basisprijs",
  "estimate_cost": "Geschatte kosten",
  "estimate_features": "Belangrijkste kenmerken",
  "hosting_title": "Hostingpakketten",
  "hosting_subtitle": "Betrouwbare, snelle hosting voor uw bedrijf",
  "sp_health_score": "Website-gezondheidsscore",
  "sp_health_score_desc": "Uitgebreide website-analyse van SEO, prestaties, beveiliging en toegankelijkheid.",
  "sp_health_score_name": "Website-gezondheidsscore",
  "sp_health_score_feat": "SEO-analyse|Prestatiecheck|Beveiligingsscan|Toegankelijkheidsaudit|Gedetailleerd rapport|Verbeteringstips",
  "sp_hosting_name": "Beheerde webhosting",
  "sp_hosting_desc": "Veilige, snelle en betrouwbare hostinginfrastructuur voor uw websites en applicaties.",
  "sp_hosting_feat": "99,9% uptime|SSL-certificaten|Dagelijkse back-ups|CDN-integratie|24/7 monitoring|Auto-schaling",
  "sp_biz_plan_name": "Slim businessplan",
  "sp_biz_plan_desc": "Genereer een uitgebreid businessplan met financiën, marktanalyse en groeistrategie.",
  "sp_biz_plan_feat": "Samenvatting|Marktanalyse|Financiële prognoses|Concurrentieoverzicht|Groeistrategie|Investeerdersformaat",
  "sp_seo_report_name": "Website-auditrapport",
  "sp_seo_report_desc": "Geautomatiseerde site-analyse met bruikbare SEO-aanbevelingen en prestatie-inzichten.",
  "sp_seo_report_feat": "100+ controlepunten|Prestatiecijfers|SEO-aanbevelingen|Mobiele analyse|Beveiligingscontrole|Actieplan",
  "sp_email_campaign_name": "E-mailmarketingopzet",
  "sp_email_campaign_desc": "Professionele e-mailcampagne-opzet met tekst, sequenties en doelgroeptargeting.",
  "sp_email_campaign_feat": "E-mailteksten|Sequentie-opzet|Doelgroeptargeting|A/B-tests|Analytics-opzet|Sjabloonontwerp",
  "sp_competitor_name": "Concurrentieanalyse",
  "sp_competitor_desc": "Diepgaande concurrentie-informatie met SEO-vergelijking, ontwerpbeoordeling en inhoudsanalyse.",
  "sp_competitor_feat": "SEO-vergelijking|Ontwerpbeoordeling|Inhoudsgaten|Marktpositionering|SWOT-analyse|Strategische aanbevelingen",
  "sp_legal_docs_name": "Juridische documentgenerator",
  "sp_legal_docs_desc": "Professionele juridische sjablonen inclusief NDA, contracten en Algemene voorwaarden.",
  "sp_legal_docs_feat": "NDA-sjablonen|Servicecontracten|Algemene voorwaarden|Privacybeleid|AVG-conformiteit|Aangepaste clausules",
  "sp_resume_name": "Slimme CV-builder",
  "sp_resume_desc": "Maak ATS-geoptimaliseerde CV's afgestemd op uw doelfunctie en sector.",
  "sp_resume_feat": "ATS-optimalisatie|Sectorsjablonen|Zoekwoordmatching|Begeleidende brief|LinkedIn-optimalisatie|PDF-export",
  "sp_brand_kit_name": "Slim logo & merkpakket",
  "sp_brand_kit_desc": "Compleet merkidentiteitspakket met logoconcepten, kleurenpalet en sociale media-assets.",
  "sp_brand_kit_feat": "Logoconcepten|Kleurenpalet|Typografie|Sociale media-assets|Merkrichtlijnen|Iconenset",
  "sp_social_cal_name": "Sociale mediakalender",
  "sp_social_cal_desc": "30 dagen intelligent gegenereerde berichten met engagement-strategie.",
  "sp_social_cal_feat": "30-dagenkalender|Berichtteksten|Hashtagstrategie|Engagementtips|Beste posttijden|Platformoptimalisatie",
  "sp_translation_name": "Slimme vertaling",
  "sp_translation_desc": "Professionele documentvertaling in 50+ talen met culturele aanpassing.",
  "sp_translation_feat": "50+ talen|Culturele aanpassing|Technische termen|Snelle levering|Proeflezen|Formaatbehoud",
  "sp_video_script_name": "Slimme videoscriptschrijver",
  "sp_video_script_desc": "Boeiende videoscripts voor YouTube, TikTok en advertenties, geoptimaliseerd voor maximaal engagement.",
  "sp_video_script_feat": "YouTube-scripts|TikTok-content|Advertentietekst|Hook-optimalisatie|CTA-plaatsing|Engagementtips",
  "sp_free_seo_name": "Gratis SEO-audit",
  "sp_free_seo_desc": "Voer een gratis uitgebreide SEO-audit uit op elke website om optimalisatiekansen te ontdekken.",
  "sp_free_seo_feat": "Directe resultaten|100+ controles|Prestatiescore|Mobiele controle|Beveiligingsscan|Gratis rapport",
  "sp_free_tools_name": "Gratis digitale tools",
  "sp_free_tools_desc": "Toegang tot onze verzameling gratis tools inclusief kleurenpaletten, kopanalysator en meer.",
  "sp_free_tools_feat": "Kleurenpaletgenerator|Kopanalysator|Wachtwoordgenerator|QR-codegenerator|Eenhedenomzetter|Zonder registratie",
  "admin_chat_analytics": "Chatanalyse",
  "admin_ab_testing": "A/B-testen",
  "admin_ui_toggles": "UI-schakelaars",
  "admin_audit_trail": "Auditspoor",
  "admin_adv_reports": "Geavanceerde rapporten",
  "admin_rate_limiting": "Snelheidsbeperking",
  "admin_email_builder": "E-mailbouwer",
  "admin_rbac": "Toegangscontrole",
  "admin_social_auto": "Sociale automatisering",
  "admin_health_monitor": "Gezondheidsmonitoring",
  "profile_country": "Land",
  "profile_country_ph": "bijv. Nederland, België, Duitsland",
  "health_title": "Website-gezondheidsscore",
  "health_desc": "Uitgebreide analyse van SEO, prestaties, beveiliging en toegankelijkheid in één dashboard.",
  "health_premium_badge": "Premium functie",
  "health_url_ph": "Voer website-URL in (bijv. voorbeeld.nl)",
  "health_scan_btn": "Scannen",
  "health_scanning": "Scannen...",
  "health_scan_error": "Website scannen mislukt. Controleer de URL.",
  "health_overall": "Totale gezondheidsscore",
  "health_response": "Respons",
  "health_size": "Grootte",
  "health_seo": "SEO",
  "health_perf": "Prestaties",
  "health_security": "Beveiliging",
  "health_a11y": "Toegankelijkheid",
  "health_history": "Scangeschiedenis",
  "health_login_required": "Log in om de gezondheidsscore te gebruiken",
  "health_login_desc": "Maak een gratis account aan om uw website te scannen en verbeteringen bij te houden.",
  "health_upsell_title": "Wilt u periodieke monitoring?",
  "health_upsell_desc": "Upgrade naar Premium voor automatische wekelijkse scans, e-mailmeldingen en trendmonitoring.",
  "health_upgrade_btn": "Upgraden naar Premium",
  "seo_cta_title": "Hulp nodig bij het oplossen van deze problemen?",
  "seo_cta_desc": "Onze intelligente SEO-audit dekt 100+ controlepunten. Krijg professionele hulp bij het optimaliseren.",
  "walkthrough_gmail": "Slimme Gmail-assistent",
  "walkthrough_gmail_desc": "Zie hoe RisTA uw inbox organiseert",
  "walkthrough_calendar": "Persoonlijke adviseur",
  "walkthrough_calendar_desc": "Agenda, taken en e-mail via chat",
  "walkthrough_ai": "Intelligente systeemdiensten",
  "walkthrough_ai_desc": "CV, businessplannen, merkpakketten en meer",
  "submit_service_request": "Dien uw serviceverzoek in",
  "profile_admin_dashboard": "Open beheerdersdashboard",
  "profile_appearance": "Uiterlijk en toegankelijkheid",
  "profile_theme": "Thema",
  "profile_text_size": "Tekstgrootte",
  "profile_text_size_hint": "Pas de tekstgrootte aan voor gemakkelijker lezen.",
  "try_free_title": "Gratis tools en proefservices",
  "try_free_subtitle": "Geen creditcard nodig. Begin direct met onze tools.",
  "try_free_section": "Volledig gratis — geen account nodig",
  "try_free_trial_section": "Intelligente systeemdiensten — Probeer met credits",
  "try_free_trial_desc": "Meld u aan voor een plan om credits te krijgen en toegang tot slimme services.",
  "try_free_cta": "Klaar om te beginnen?",
  "try_free_cta_desc": "Maak een gratis account aan om uw eerste credits te ontvangen en alle slimme services te ontgrendelen.",
  "try_free_cta_btn": "Gratis registreren",
  "review_title": "Wat onze klanten zeggen",
  "review_subtitle": "Echte feedback van bedrijven die we hebben geholpen",
  "testimonial_1_role": "CEO, TechStart d.o.o.",
  "testimonial_2_role": "Marketingdirecteur, BioFresh",
  "testimonial_3_role": "Freelance ontwikkelaar",
  "admin_overview": "Overzicht",
  "admin_my_account": "Mijn account",
  "admin_health": "Gezondheidsmonitor",
  "admin_analytics": "Analyse",
  "admin_integrations": "Integraties",
  "admin_requests": "Serviceaanvragen",
  "admin_high_value": "Waardevolle leads",
  "admin_followups": "Follow-up e-mails",
  "admin_users": "Gebruikersbeheer",
  "admin_crypto_payments": "Cryptobetalingen",
  "admin_bug_reports": "Foutmeldingen",
  "admin_pricing": "Dynamische prijzen",
  "admin_defi": "DeFi-items",
  "admin_chat_sessions": "Chatsessies",
  "admin_language_requests": "Taalverzoeken",
  "admin_notifications": "Meldingen",
  "admin_sendgrid": "E-mail (SendGrid)",
  "admin_ai_config": "Modelconfiguratie",
  "admin_live_analytics": "Live analyse",
  "admin_system_config": "Systeemconfiguratie",
  "admin_backup": "Back-up en herstel",
  "admin_referrals": "Verwijzingsprogramma",
  "admin_invoices": "Facturering",
  "admin_billing": "Terugkerende facturering",
  "admin_blog": "Blogbeheer",
  "admin_logo": "Logo en favicon",
  "admin_promo": "Promotiecodes",
  "admin_currency": "Multivaluta",
  "admin_domain": "Domeinbeheer",
  "admin_cdn": "CDN-beheer",
  "admin_social": "Sociale media",
  "admin_avatar_selector": "Avatarselectie",
  "admin_avatar_builder": "Avatarbouwer",
  "admin_client_portal": "Klantenportaal",
  "admin_abandoned_carts": "Verlaten winkelwagens",
  "rista_login_required": "Inloggen vereist",
  "rista_login_desc": "Log in of maak een account aan om met RisTA te chatten en gepersonaliseerde zakelijke aanbevelingen te ontvangen.",
  "rista_login_btn": "Inloggen",
  "rista_signup_btn": "Registreren",
  "admin_high_leads": "Prioritaire leads",
  "admin_surveys": "Tevredenheidsonderzoeken",
  "admin_rista": "RisTA-diensten",
  "admin_docs": "Documentatie",
  "admin_audit": "Platformaudit",
  "admin_kb": "Kennisbank",
  "admin_reports": "Beheerdersrapporten",
  "admin_ad_gen": "Advertentiegenerator",
  "admin_service_mgr": "Servicebeheer",
  "admin_tester": "Testprogramma",
  "admin_credits": "Creditconfiguratie",
  "admin_account_mgmt": "Accountbeheer",
  "admin_payment_opts": "Betalingsopties",
  "admin_lead_tracking": "Leadtracking",
  "admin_demo": "Demo-toegang",
  "admin_crypto_trading": "Cryptohandel",
  "admin_auto_posting": "Slim auto-posten",
  "admin_fb": "FB-analyse",
  "admin_referral_board": "Verwijzingsranglijst",
  "admin_escalations": "Chat-escalaties",
  "admin_portfolio": "Portfoliobeheer",
  "admin_email_templates": "E-mailsjablonen",
  "admin_social_icons": "Sociale iconen",
  "admin_ai_prompts": "Slimme prompts",
  "admin_panel": "Beheerderspaneel",
  "admin_sign_out": "Uitloggen",
  "admin_search_tabs": "Zoek tabbladen...",
  "admin_demo_banner": "ALLEEN-LEZEN MODUS - Demo-account (Alle gebruikersgegevens zijn gemaskeerd)",
  "admin_system_admin": "SYSTEEMBEHEERDER",
  "admin_loading": "Laden...",
  "admin_no_matching": "Geen overeenkomende tabbladen",
  "tester_req_1": "Log minstens 5 keer per week in",
  "tester_req_2": "Dien minstens 10 bug/feedbackrapporten per week in",
  "tester_req_3": "Test verschillende functies, pagina's en gebruikersstroom",
  "tester_benefit_1": "Gratis toegang tot intelligente diensten (op aanvraag)",
  "tester_benefit_2": "Testerdashboard met voortgangsmonitoring",
  "tester_benefit_3": "Prioritaire ondersteuning van het team",
  "tester_motivation": "Waarom wilt u tester worden?",
  "tester_motivation_ph": "Vertel ons waarom u het platform wilt helpen testen...",
  "tester_experience": "Testervaring (optioneel)",
  "tester_experience_ph": "Relevante ervaring...",
  "tester_dash_desc": "Houd uw testerstatus actief door wekelijkse doelen te halen.",
  "tester_logins_needed": "meer logins nodig deze week",
  "tester_reports_needed": "meer rapporten nodig deze week",
  "tester_report_title_ph": "Titel (bijv. 'Knop niet klikbaar op mobiel')",
  "tester_report_desc_ph": "Beschrijf het probleem of de suggestie in detail...",
  "tester_report_page_ph": "Pagina-URL (optioneel)",
  "seo_page_desc": "Voer een URL in voor een uitgebreide SEO-analyse met bruikbare aanbevelingen.",
  "seo_page_ph": "Voer website-URL in (bijv. voorbeeld.nl)",
  "seo_page_error": "Audit mislukt. Controleer de URL en probeer opnieuw.",
  "profile_bio_ph": "Vertel ons over uzelf...",
  "profile_website_ph": "https://uwwebsite.nl",
  "profile_interests_ph": "bijv. Webontwikkeling, Crypto, Tech",
  "admin_notes_ph": "Voeg een notitie toe over deze gebruiker...",
  "profile_change_avatar": "Avatar wijzigen",
  "profile_about": "Over u",
  "profile_interests_hint": "Scheid interesses met komma's",
  "privacy_s1_title": "1. Informatie die wij verzamelen",
  "privacy_s2_title": "2. Hoe wij uw informatie gebruiken",
  "privacy_s3_title": "3. Gegevens delen",
  "privacy_s4_title": "4. Gegevensbeveiliging",
  "privacy_s5_title": "5. Uw rechten",
  "privacy_s6_title": "6. Cookies en tracking",
  "privacy_s7_title": "7. Gegevensbewaring",
  "privacy_s8_title": "8. Internationale overdrachten",
  "privacy_s9_title": "9. Wijzigingen in dit beleid",
  "privacy_s10_title": "10. Neem contact op",
  "privacy_intro": "Infinity Business (\"wij\", \"ons\"), geëxploiteerd door Liber Nostra d.o.o., zet zich in voor de bescherming van uw privacy.",
  "privacy_last_updated": "Laatst bijgewerkt: 7 maart 2026",
  "terms_s1_title": "1. Inleiding",
  "terms_s2_title": "2. Diensten",
  "terms_s3_title": "3. Gebruikersaccounts",
  "terms_s4_title": "4. Betalingen en facturering",
  "terms_s5_title": "5. Disclaimer intelligente diensten",
  "terms_s6_title": "6. Intellectueel eigendom",
  "terms_s7_title": "7. Privacy en gegevens",
  "terms_s8_title": "8. Cryptocurrency disclaimer",
  "terms_s9_title": "9. Beperking van aansprakelijkheid",
  "terms_s10_title": "10. Wijzigingen",
  "terms_s11_title": "11. Toepasselijk recht",
  "terms_s12_title": "12. Contact",
  "terms_last_updated": "Laatst bijgewerkt: februari 2026",
  "referral_subtitle": "Nodig vrienden uit en verdien beloningen",
  "marketplace_close_preview": "Voorbeeld sluiten",
  "marketplace_live_preview": "Live voorbeeld",
  "billing_management": "Factureringsbeheer",
  "billing_manage_desc": "Beheer uw betaalmethoden, bekijk facturen via het Stripe-portaal.",
  "billing_manage_btn": "Facturering beheren",
  "billing_cancel_btn": "Plan annuleren",
  "change_password_current": "Huidig wachtwoord",
  "change_password_new": "Nieuw wachtwoord",
  "change_password_confirm": "Nieuw wachtwoord bevestigen",
  "change_password_btn": "Wachtwoord wijzigen",
  "change_password_social": "Wachtwoord wijzigen is niet beschikbaar voor sociale login accounts.",
  "nav_currency": "Valuta",
  "nav_orders": "Mijn bestellingen",
  "plan_features": "Functies van uw plan",
  "project_no_projects": "Nog geen projecten. Projecten verschijnen hier zodra u een dienst aanschaft.",
  "onboarding_services_title": "Ontdek onze diensten",
  "onboarding_services_subtitle": "Twee categorieën op maat voor u",
  "onboarding_services_content": "Wij bieden twee categorieën diensten:",
  "onboarding_services_item1": "B2B: Webontwikkeling, mobiele apps, grafisch ontwerp, hosting, software, advertenties, API",
  "onboarding_services_item2": "P2P: Crypto-educatie, DeFi, domeinen, beheerde handel, digitale tools",
  "onboarding_services_item3": "Slimme microtools: Marktsnapshots, concurrentieanalyse, e-mailgeneratoren, blogoutlines, TAM-calculators, en meer",
  "onboarding_services_item4": "Praat op elk moment met RisTA voor persoonlijke offertes en serviceaanbevelingen",
  "onboarding_credits_title": "Creditsysteem",
  "onboarding_credits_subtitle": "Prepaid tegoed voor slimme services",
  "onboarding_credits_content": "Gebruik credits voor directe toegang tot onze slimme services:",
  "onboarding_credits_item1": "1 EUR = 1 credit. Basic: 29 credits, Premium: 79, Lifetime: 499",
  "onboarding_credits_item2": "Gratis tools zonder credits. Betaalde microtools kosten $1 per stuk",
  "onboarding_credits_item3": "Volumekorting: 5% bij 50+ EUR, 10% bij 100+, 15% bij 250+, 20% bij 500+",
  "onboarding_credits_item4": "Opwaarderen met kaart, PayPal, myPOS of crypto via het Creditpaneel",
  "onboarding_chat_title": "Praat met RisTA",
  "onboarding_chat_subtitle": "Uw digitale partner staat klaar",
  "onboarding_chat_content": "RisTA kan u helpen met:",
  "onboarding_chat_item1": "Projectschattingen en offertes",
  "onboarding_chat_item2": "Serviceopties in detail verkennen",
  "onboarding_chat_item3": "Serviceaanvragen indienen",
  "onboarding_chat_item4": "Vragen beantwoorden in 11 talen",
  "support_tickets": "Supporttickets",
  "admin_support_tickets": "Supporttickets",
  "admin_auto_translate": "Auto-vertaling",
  "admin_telegram": "Telegram",
  "admin_ai_prospecting": "AI-prospectie",
  "admin_project_mgmt": "Projectbeheer",
  "admin_analytics_widget": "Analyse-widget",
  "admin_doc_mgmt": "Documentbeheer",
  "admin_webhooks": "Webhooks",
  "admin_white_label": "White label",
  "admin_multi_tenant": "Multi-tenant",
  "popular_services": "Populaire diensten",
  "popular_services_desc": "Meest gevraagd door onze klanten",
  "purchases": "Aankopen",
  "admin_funnel": "Conversietrechter",
  "admin_wl_licensing": "SaaS-licenties",
  "admin_analytics_export": "Analytics-export",
  "service_detail_features": "Wat is inbegrepen",
  "service_detail_related": "Gerelateerde diensten",
  "service_detail_back": "Alle diensten",
  "checkout_currency": "Afrekening valuta",
  "upsell_title": "Maak uw setup compleet",
  "upsell_desc": "Klanten die vergelijkbaar kochten, voegden ook toe:",
  "cart_checkout": "Afrekenen",
  "cart_empty": "Uw winkelwagen is leeg",
  "push_notifications": "Push-meldingen",
  "push_enabled": "Meldingen ingeschakeld",
  "push_disabled": "Meldingen inschakelen",
  "blog_ai_generate": "AI-generatie",
  "blog_gen_service": "Genereer voor dienst",
  "blog_generating": "Genereren...",
  "export_revenue": "Omzetrapport",
  "export_funnel": "Conversietrechter",
  "export_users": "Gebruikerslijst",
  "export_pdf": "Samenvatting",
  "license_generate": "Licentie genereren",
  "license_revoke": "Intrekken",
  "license_renew": "Verlengen",
  "license_validate": "Valideren",
  "tier_starter": "Starter",
  "tier_professional": "Professional",
  "tier_enterprise": "Enterprise",
  "blog_subtitle": "Inzichten, updates en gidsen van Infinity Business.",
  "blog_search_placeholder": "Artikelen zoeken...",
  "blog_all": "Alles",
  "blog_no_posts": "Geen berichten gevonden. Kom snel terug!",
  "blog_prev": "Vorige",
  "blog_next": "Volgende",
  "blog_back": "Terug naar blog",
  "micro_tools": "Slimme micro-tools",
  "micro_tools_title": "Slimme micro-tools",
  "micro_tools_subtitle": "Gratis AI-aangedreven micro-tools voor uw bedrijf",
  "color_palette_title": "Kleurpaletgenerator",
  "color_palette_desc": "Genereer mooie kleurpaletten voor uw merk",
  "color_palette_generate": "Genereer palet",
  "color_palette_copy": "Kopiëren",
  "color_palette_copied": "Gekopieerd!",
  "color_palette_hex": "HEX",
  "color_palette_rgb": "RGB",
  "color_palette_hsl": "HSL",
  "color_palette_complementary": "Complementair",
  "color_palette_analogous": "Analoog",
  "color_palette_triadic": "Triadisch",
  "color_palette_monochromatic": "Monochromatisch",
  "admin_menu_overview": "Overzicht",
  "admin_menu_users": "Gebruikers",
  "admin_menu_blog": "Blogbeheer",
  "admin_menu_analytics": "Analyse",
  "admin_menu_settings": "Instellingen",
  "admin_menu_services": "Diensten",
  "admin_menu_chat": "Chatsessies",
  "admin_menu_notifications": "Meldingen",
  "admin_menu_support": "Ondersteuning",
  "admin_menu_security": "Beveiliging",
  "admin_menu_backup": "Back-up",
  "admin_menu_revenue": "Omzet",
  "admin_menu_funnel": "Trechter",
  "admin_menu_invoicing": "Facturering",
  "admin_menu_projects": "Projecten",
  "admin_menu_email": "E-mail builder",
  "admin_menu_ai_config": "AI-configuratie",
  "admin_menu_live_analytics": "Live analyse",
  "admin_menu_platform_audit": "Platform audit",
  "docs_title": "Documentatie",
  "docs_subtitle": "Leer hoe u ons platform kunt gebruiken",
  "try_free_title": "Gratis proberen",
  "try_free_subtitle": "Ervaar onze diensten gratis",
  "subscription_title": "Abonnementen",
  "subscription_subtitle": "Kies het plan dat bij u past",
  "portfolio_title": "Portfolio",
  "portfolio_subtitle": "Ons werk spreekt voor zich",
  "svc_web-dev_label": "Webontwikkeling",
  "svc_web-dev_desc": "Websites, landingspagina's en webapplicaties",
  "svc_mobile-app_label": "Mobiele App Ontwikkeling",
  "svc_mobile-app_desc": "iOS & Android apps, cross-platform",
  "svc_graphic-design_label": "Grafisch Ontwerp",
  "svc_graphic-design_desc": "Logo's, branding, marketingmateriaal",
  "svc_custom-software_label": "Maatwerk Software",
  "svc_custom-software_desc": "Op maat gemaakte bedrijfsautomatisering",
  "svc_ai-business-plan_label": "Slim Businessplan Generator",
  "svc_ai-business-plan_desc": "Compleet businessplan met financiën en marktanalyse",
  "svc_ai-seo-report_label": "Website Audit & SEO Rapport",
  "svc_ai-seo-report_desc": "Geautomatiseerde analyse met aanbevelingen",
  "svc_ai-email-campaign_label": "E-mail Marketing Setup",
  "svc_ai-email-campaign_desc": "AI schrijft teksten en stelt e-mailreeksen in",
  "svc_ai-competitor-analysis_label": "Concurrentieanalyse Rapport",
  "svc_ai-competitor-analysis_desc": "Marktintelligentie en positionering",
  "svc_ai-legal-docs_label": "Juridisch Document Generator",
  "svc_ai-legal-docs_desc": "NDA, contracten, algemene voorwaarden",
  "svc_crypto-education_label": "Crypto Educatie",
  "svc_crypto-education_desc": "Leer blockchain, DeFi en crypto basisprincipes",
  "svc_investment-tools_label": "Investeringstools",
  "svc_investment-tools_desc": "Portfolio tracking en marktanalyse",
  "svc_defi-solutions_label": "DeFi Oplossingen",
  "svc_defi-solutions_desc": "Smart contracts, yield farming",
  "svc_personal-advertising_label": "Persoonlijke Branding",
  "svc_personal-advertising_desc": "Bouw uw online aanwezigheid",
  "svc_ai-resume_label": "Slim CV Builder",
  "svc_ai-resume_desc": "ATS-geoptimaliseerde CV's",
  "svc_ai-brand-kit_label": "Slim Logo & Brand Kit",
  "svc_ai-brand-kit_desc": "Logo, kleurenpalet, typografie en social assets",
  "svc_ai-social-calendar_label": "Social Media Kalender & Analyse",
  "svc_ai-social-calendar_desc": "30 dagen AI-gegenereerde posts",
  "svc_ai-translation_label": "Slimme Vertaalservice",
  "svc_ai-translation_desc": "Professionele vertaling in 50+ talen",
  "svc_ai-video-script_label": "Slimme Video Script Schrijver",
  "svc_ai-video-script_desc": "YouTube, TikTok en advertentiescripts",
  "admin_grp_dashboard": "Dashboard",
  "admin_grp_users": "Gebruikers & Toegang",
  "admin_grp_analytics": "Analyse & Rapporten",
  "admin_grp_services": "Diensten & Prijzen",
  "admin_grp_crypto": "Crypto & DeFi",
  "admin_grp_leads": "Leads & CRM",
  "admin_grp_content": "Inhoud",
  "admin_grp_comm": "Communicatie",
  "admin_grp_social": "Sociale Media",
  "admin_grp_ai": "AI & Automatisering",
  "admin_grp_design": "Design & Branding",
  "admin_grp_system": "Systeem",
  "admin_grp_projects": "Projecten & QA",
  "color_palette_professional": "Professioneel",
  "color_palette_playful": "Speels",
  "color_palette_luxury": "Luxe",
  "color_palette_nature": "Natuur",
  "color_palette_tech": "Tech",
  "color_palette_warm": "Warm",
  "color_palette_cool": "Koel",
  "blog_translating": "Artikel vertalen...",
  "blog_translated_cached": "Vertaald",
  "blog_translated_fresh": "Zojuist vertaald",
  "blog_show_original": "Origineel tonen",
  "privacy_s1_content": "Wij verzamelen informatie die u direct aan ons verstrekt, waaronder:\n- **Accountgegevens**: Naam, e-mail en wachtwoord bij het aanmaken van een account.\n- **Serviceverzoeken**: Projectdetails, budget en contactgegevens.\n- **Betalingsgegevens**: Facturatiegegevens verwerkt door onze partners (Stripe, myPOS).\n- **Communicatiegegevens**: Berichten via RisTA, contactformulieren en e-mail.\n- **Gebruiksgegevens**: Browsertype, IP-adres, bezochte pagina's.",
  "privacy_s2_content": "Wij gebruiken de verzamelde informatie om:\n- Onze diensten te leveren, onderhouden en verbeteren\n- Transacties te verwerken\n- Technische mededelingen en ondersteuning te sturen\n- Op uw vragen te reageren\n- Trends en activiteiten te monitoren\n- Fraude te detecteren en voorkomen\n- Uw ervaring met RisTA te personaliseren",
  "privacy_s3_content": "Wij verkopen uw persoonlijke gegevens niet. Wij kunnen informatie delen met:\n- **Dienstverleners**: Bedrijven die diensten voor ons uitvoeren.\n- **Wettelijke vereisten**: Wanneer wettelijk verplicht.\n- **Bedrijfsoverdrachten**: In verband met fusies of verkopen.\n- **Toestemming**: Met uw uitdrukkelijke toestemming.",
  "privacy_s4_content": "Wij implementeren standaard beveiligingsmaatregelen:\n- Versleuteling van gegevens in transit (TLS/SSL) en in rust\n- Ondersteuning voor tweefactorauthenticatie (2FA)\n- Regelmatige beveiligingsaudits\n- Toegangscontroles en authenticatie\n- Veilige betalingsverwerking",
  "privacy_s5_content": "Onder toepasselijke wetgeving (waaronder AVG) heeft u recht op:\n- **Toegang**: Een kopie van uw gegevens opvragen\n- **Rectificatie**: Correctie van onjuiste gegevens\n- **Verwijdering**: Verwijdering van uw gegevens\n- **Beperking**: Beperking van verwerking\n- **Overdraagbaarheid**: Overdracht in machineleesbaar formaat\n- **Bezwaar**: Bezwaar tegen verwerking\n- **Intrekking**: Toestemming intrekken\n\nNeem contact op via privacy@infinitybusiness.org.",
  "privacy_s6_content": "Wij gebruiken essentiële cookies voor uw sessie en voorkeuren. U kunt cookies beheren via uw browser.",
  "privacy_s7_content": "Wij bewaren uw gegevens alleen zolang als nodig voor de doeleinden waarvoor ze zijn verzameld.",
  "privacy_s8_content": "Uw gegevens kunnen buiten de EER worden overgedragen. Wij zorgen voor passende waarborgen.",
  "privacy_s9_content": "Wij kunnen dit privacybeleid van tijd tot tijd bijwerken. Belangrijke wijzigingen worden op deze pagina gepubliceerd.",
  "privacy_s10_content": "Voor vragen, neem contact op:\n\n**Liber Nostra d.o.o.**\nE-mail: privacy@infinitybusiness.org\nWebsite: infinitybusiness.org",
  "terms_s1_content": "Welkom bij Infinity Business (\"infinitybusiness.org\"), beheerd door **Liber Nostra d.o.o.**. Door onze platform te gebruiken, stemt u in met deze Voorwaarden.",
  "terms_s2_content": "Infinity Business biedt AI-ondersteunde digitale diensten:\n- Webontwikkeling, mobiele apps en grafisch ontwerp (B2B)\n- Bedrijfs- en digitale advertentiediensten\n- Crypto-educatie, investeringstools en DeFi (P2P)\n- RisTA AI-assistent\n- Domeinen en webhosting",
  "terms_s3_content": "Voor bepaalde functies moet u een account aanmaken. U bent verantwoordelijk voor de vertrouwelijkheid van uw inloggegevens.",
  "terms_s4_content": "Diensten kunnen betaling vereisen. Betalingen via derden (Stripe, PayPal, crypto). Restitutiebeleid:\n- **Eenmalige diensten**: Niet restitueerbaar.\n- **Abonnementen**: Op elk moment opzegbaar.\n- **Maatwerkprojecten**: Volgens individuele overeenkomst.",
  "terms_s5_content": "Onze AI-assistent \"RisTA\" biedt geautomatiseerde begeleiding. Alleen ter informatie.",
  "terms_s6_content": "Alle inhoud op dit platform is eigendom van Liber Nostra d.o.o.",
  "terms_s7_content": "Uw gebruik wordt ook beheerst door ons Privacybeleid.",
  "terms_s8_content": "Crypto-gerelateerde diensten zijn alleen informatief. Wij geven geen financieel advies.",
  "terms_s9_content": "Liber Nostra d.o.o. is niet aansprakelijk voor indirecte of gevolgschade.",
  "terms_s10_content": "Wij behouden ons het recht voor deze Voorwaarden te wijzigen.",
  "terms_s11_content": "Deze Voorwaarden vallen onder het recht van de Republiek Slovenië.",
  "terms_s12_content": "Voor vragen, neem contact op of mail naar support@infinitybusiness.org.",
  "admin_ad_generator": "Advertentie-generator",
  "admin_add": "Toevoegen",
  "admin_add_prompt": "Prompt toevoegen",
  "admin_admin": "Admin",
  "admin_advanced_reporting": "Geavanceerde rapportage",
  "admin_all": "Alle",
  "admin_analytics_dashboard": "Analytics Dashboard",
  "admin_api_key": "API Key",
  "admin_apply": "Toepassen",
  "admin_approved": "Goedgekeurd",
  "admin_archive": "Archiveren",
  "admin_are_you_sure": "Weet u het zeker?",
  "admin_audit_alerts": "Audit-meldingen",
  "admin_author": "Auteur",
  "admin_avg_session": "Gemiddelde sessie",
  "admin_back": "Terug",
  "admin_badge": "Badge",
  "admin_balance": "Saldo",
  "admin_banned": "Verbannen",
  "admin_blog_manager": "Blogbeheerder",
  "admin_body": "Body",
  "admin_bounce_rate": "Bouncepercentage",
  "admin_browser": "Browser",
  "admin_campaign": "Campagne",
  "admin_cannot_undo": "Deze actie kan niet ongedaan worden gemaakt",
  "admin_category": "Categorie",
  "admin_click_rate": "Klikratio",
  "admin_close": "Sluiten",
  "admin_completed": "Voltooid",
  "admin_configuration": "Configuratie",
  "admin_confirm": "Bevestigen",
  "admin_contact_info": "Contactinfo",
  "admin_content": "Inhoud",
  "admin_conversations": "Gesprekken",
  "admin_conversion_funnel": "Conversietrechter",
  "admin_conversion_rate": "Conversieratio",
  "admin_copied": "Gekopieerd naar klembord",
  "admin_copy": "Kopiëren",
  "admin_count": "Aantal",
  "admin_country": "Land",
  "admin_create": "Aanmaken",
  "admin_create_experiment": "Experiment aanmaken",
  "admin_create_new": "Nieuwe aanmaken",
  "admin_created_success": "Succesvol aangemaakt",
  "admin_credit_config": "Credit-configuratie",
  "admin_critical": "Kritiek",
  "admin_custom": "Aangepast",
  "admin_daily": "Dagelijks",
  "admin_date": "Datum",
  "admin_delete_failed": "Verwijderen mislukt",
  "admin_deleted_success": "Succesvol verwijderd",
  "admin_demo_access": "Demo-toegang",
  "admin_description": "Beschrijving",
  "admin_deselect_all": "Alles deselecteren",
  "admin_details": "Details",
  "admin_device": "Apparaat",
  "admin_disable": "Uitschakelen",
  "admin_disabled": "Uitgeschakeld",
  "admin_doc_viewer": "Document-viewer",
  "admin_documentation": "Documentatie",
  "admin_download": "Downloaden",
  "admin_draft": "Concept",
  "admin_duplicate": "Dupliceren",
  "admin_email": "E-mail",
  "admin_enable": "Inschakelen",
  "admin_enabled": "Ingeschakeld",
  "admin_end_date": "Einddatum",
  "admin_endpoint": "Endpoint",
  "admin_error": "Fout",
  "admin_escalation_queue": "Escalatiewachtrij",
  "admin_event": "Event",
  "admin_events": "Events",
  "admin_experiment_name": "Experimentnaam",
  "admin_export": "Exporteren",
  "admin_facebook_analytics": "Facebook Analytics",
  "admin_false": "Onwaar",
  "admin_filter": "Filteren",
  "admin_frequency": "Frequentie",
  "admin_generate": "Genereren",
  "admin_headers": "Headers",
  "admin_health_monitoring": "Systeemmonitoring",
  "admin_high": "Hoog",
  "admin_high_value_leads": "Hoogwaardige leads",
  "admin_id": "ID",
  "admin_image": "Afbeelding",
  "admin_import": "Importeren",
  "admin_in_progress": "In uitvoering",
  "admin_inactive": "Inactief",
  "admin_inbox": "Admin Inbox",
  "admin_speed_audit": "Snelheidsaudit",
  "admin_info": "Info",
  "admin_ip_address": "IP Address",
  "admin_joined": "Lid geworden",
  "admin_knowledge_base": "Knowledge Base",
  "admin_language": "Taal",
  "admin_last_activity": "Laatste activiteit",
  "admin_last_login": "Laatste login",
  "admin_last_triggered": "Laatst geactiveerd",
  "admin_lead_score": "Lead Score",
  "admin_level": "Niveau",
  "admin_load_failed": "Laden mislukt",
  "admin_loading_data": "Gegevens laden...",
  "admin_low": "Laag",
  "admin_medium": "Gemiddeld",
  "admin_messages": "Berichten",
  "admin_method": "Method",
  "admin_monetization": "Monetisatie",
  "admin_monthly": "Maandelijks",
  "admin_name": "Naam",
  "admin_next": "Volgende",
  "admin_no": "Nee",
  "admin_no_data_available": "Geen gegevens beschikbaar",
  "admin_no_experiments": "Geen experimenten gevonden",
  "admin_no_leads": "Geen leads gevonden",
  "admin_no_prompts": "Geen prompts gevonden",
  "admin_no_results": "Geen resultaten",
  "admin_no_results_found": "Geen resultaten gevonden",
  "admin_none": "Geen",
  "admin_off": "Uit",
  "admin_on": "Aan",
  "admin_open_rate": "Openingsratio",
  "admin_page_views": "Paginaweergaven",
  "admin_partner_badges": "Partnerbadges",
  "admin_payload": "Payload",
  "admin_payment_options": "Betaalopties",
  "admin_platform": "Platform",
  "admin_platform_audit": "Platform-audit",
  "admin_points": "Punten",
  "admin_portfolio_manager": "Portfoliobeheerder",
  "admin_preloader_config": "Preloader-config",
  "admin_preview": "Voorbeeld",
  "admin_previous": "Vorige",
  "admin_price": "Prijs",
  "admin_priority": "Prioriteit",
  "admin_prompt_name": "Promptnaam",
  "admin_prompt_text": "Prompt-tekst",
  "admin_published": "Gepubliceerd",
  "admin_recipients": "Ontvangers",
  "admin_referral": "Referral",
  "admin_referral_leaderboard": "Referral-klassement",
  "admin_refresh": "Vernieuwen",
  "admin_rejected": "Afgewezen",
  "admin_remove": "Verwijderen",
  "admin_reset": "Resetten",
  "admin_response_time": "Responstijd",
  "admin_restore": "Herstellen",
  "admin_results": "Resultaten",
  "admin_retry": "Opnieuw proberen",
  "admin_revenue_dashboard": "Omzetdashboard",
  "admin_rista_services": "RisTA Services",
  "admin_role": "Rol",
  "admin_save_changes": "Wijzigingen opslaan",
  "admin_save_failed": "Opslaan mislukt",
  "admin_saved_success": "Succesvol opgeslagen",
  "admin_scheduled": "Ingepland",
  "admin_search": "Zoeken",
  "admin_select": "Selecteren",
  "admin_select_all": "Alles selecteren",
  "admin_send": "Versturen",
  "admin_sent_success": "Succesvol verzonden",
  "admin_server_resources": "Serverbronnen",
  "admin_service_manager": "Servicebeheerder",
  "admin_session_duration": "Sessieduur",
  "admin_settings": "Instellingen",
  "admin_slug": "Slug",
  "admin_social_automation": "Sociale automatisering",
  "admin_something_wrong": "Er is iets misgegaan",
  "admin_source": "Bron",
  "admin_start_date": "Startdatum",
  "admin_subject": "Onderwerp",
  "admin_submit": "Verzenden",
  "admin_subscribers": "Abonnees",
  "admin_success": "Succes",
  "admin_suspended": "Geschorst",
  "admin_system_prompt": "System Prompt",
  "admin_tags": "Tags",
  "admin_template": "Template",
  "admin_templates": "Templates",
  "admin_test_results": "Testresultaten",
  "admin_tester_program": "Tester-programma",
  "admin_title": "Titel",
  "admin_total_revenue": "Totale omzet",
  "admin_total_sessions": "Totaal aantal sessies",
  "admin_total_users": "Totaal aantal gebruikers",
  "admin_trigger": "Trigger",
  "admin_true": "Waar",
  "admin_try_again": "Probeer het opnieuw",
  "admin_type": "Type",
  "admin_unique_visitors": "Unieke bezoekers",
  "admin_unsubscribed": "Afgemeld",
  "admin_unverified": "Niet geverifieerd",
  "admin_update": "Bijwerken",
  "admin_updated_success": "Succesvol bijgewerkt",
  "admin_upload": "Uploaden",
  "admin_urgent": "Urgent",
  "admin_user": "Gebruiker",
  "admin_variant_a": "Variant A",
  "admin_variant_b": "Variant B",
  "admin_verified": "Geverifieerd",
  "admin_version": "Versie",
  "admin_view": "Bekijken",
  "admin_view_details": "Details bekijken",
  "admin_viewer": "Kijker",
  "admin_warning": "Waarschuwing",
  "admin_webhook_url": "Webhook URL",
  "admin_weekly": "Wekelijks",
  "admin_yes": "Ja",
  "admin_analytics_digestadmin_analytics_digest": "Analyse samenvatting",
  "admin_blog_health": "Blog gezondheid",
  "credit_title": "Tegoed",
  "credit_subtitle": "Prepaid saldo voor intelligente diensten",
  "credit_available_balance": "Beschikbaar saldo",
  "credit_tab_balance": "Saldo",
  "credit_tab_topup": "Opwaarderen",
  "credit_tab_history": "Geschiedenis",
  "credit_tab_services": "Diensten",
  "credit_tab_crypto": "Crypto",
  "credit_balance_desc": "Uw tegoed kan worden gebruikt voor elke AI-dienst:",
  "credit_bulk_discounts": "Volumekortingen",
  "credit_add_credits": "Tegoed toevoegen",
  "credit_select_amount": "Selecteer een bedrag of voer een aangepaste waarde in:",
  "credit_bonus": "bonus",
  "credit_bonus_detail": "U krijgt",
  "credit_total_word": "totaal",
  "credit_method_card": "Kaart",
  "credit_method_crypto": "Crypto",
  "credit_processing": "Verwerken...",
  "credit_add_btn": "Toevoegen",
  "credit_no_txn": "Nog geen transacties",
  "credit_txn_topup": "Opwaardering",
  "credit_txn_promo": "Promo-tegoed",
  "credit_txn_auto": "Automatische aankoop",
  "credit_txn_purchase": "Aankoop",
  "credit_svc_intelligent": "Intelligente dienst",
  "credit_svc_available": "Beschikbaar",
  "credit_svc_need_more": "Nodig",
  "credit_svc_more": "meer",
  "credit_crypto_send": "Verstuur",
  "credit_crypto_amount": "Bedrag:",
  "credit_crypto_equivalent": "equivalent",
  "credit_crypto_network": "Netwerk:",
  "credit_crypto_wallet": "Wallet-adres",
  "credit_crypto_confirm": "Tegoed wordt toegevoegd na bevestiging van de transactie.",
  "credit_payment_id": "Betalings-ID:",
  "credit_crypto_back": "Terug naar crypto-selectie",
  "credit_crypto_select_title": "Selecteer cryptocurrency voor opwaardering",
  "credit_crypto_choose_desc": "Kies een munt. U ontvangt een wallet-adres voor betaling.",
  "credit_crypto_select_btn": "Selecteren",
  "credit_minimum": "Minimum €5",
  "credit_redirecting": "Doorverwijzen...",
  "credit_topup_failed": "Opwaardering mislukt",
  "credit_crypto_failed": "Crypto-betaling niet gestart",
  "cart_title": "Winkelwagen",
  "cart_total": "Totaal",
  "cart_stripe_checkout": "Stripe-afrekenen",
  "cart_credits": "Tegoed",
  "cart_secure_stripe": "Veilig Stripe-afrekenen",
  "cart_insufficient": "Onvoldoende tegoed. Waardeer eerst op of kies kaartbetaling.",
  "cart_pay_card": "Betaal met kaart",
  "cart_pay_credits_btn": "Betaal met tegoed",
  "cart_clear": "Winkelwagen legen",
  "cart_processing": "Verwerken...",
  "cart_payment_success": "Betaling geslaagd! Uw bestelling wordt verwerkt.",
  "cart_complete_setup": "Voltooi uw instellingen",
  "cart_also_added": "Klanten met vergelijkbare aankopen voegden ook toe:",
  "cart_add": "Toevoegen",
  "cart_standard": "Standaard",
  "cart_remaining_balance": "Resterend saldo:",
  "cart_checkout_failed": "Afrekenen mislukt",
  "cart_checkout_no_session": "Kan afrekenensessie niet aanmaken",
  "cart_purchased": "Gekocht",
  "cart_services_with_credits": "dienst(en) met tegoed!",
  "credits_balance_title": "Tegoed-saldo",
  "credits_topup_btn": "Tegoed opwaarderen",
  "credits_rate": "1 EUR = 1 Credit",
  "credits_total_topup": "Totaal opgewaardeerd",
  "credits_spent_credits": "Uitgegeven (Tegoed)",
  "credits_spent_payments": "Uitgegeven (Betalingen)",
  "credits_txn_history": "Transactiegeschiedenis",
  "credits_no_txn": "Geen transacties",
  "credits_txn_topup": "Opwaardering",
  "credits_txn_promo": "Promo-tegoed",
  "credits_txn_purchase": "Dienstaankoop",
  "credits_txn_ai": "AI-dienst",
  "credits_order_history": "Bestelgeschiedenis",
  "credits_order_label": "Bestelling:",
  "chat_translate_btn": "Vertaal naar Engels",
  "chat_translating": "Vertalen...",
  "chat_translated_label": "Engelse vertaling wordt weergegeven. Klik op \"Origineel tonen\" voor de originele berichten.",
  "chat_show_original": "Origineel tonen",
  "chat_show_translated": "Vertaling tonen",
  "pkg_section_badge": "Aanbiedingen voor beperkte tijd",
  "pkg_section_title": "Start Je Bedrijf",
  "pkg_section_title_highlight": "Vandaag",
  "pkg_section_subtitle": "Premium pakketten ontworpen om je snel online te krijgen - met slimme technologie ingebouwd vanaf dag één.",
  "pkg_section_footer": "Alle prijzen zijn exclusief BTW waar van toepassing. Niet zeker welk pakket bij je past? Chat met RisTA voor een gratis consult.",
  "pkg_cta_default": "Aan de Slag",
  "admin_package_mgr": "Pakketbeheer",
  "admin_pkg_title": "Landingspagina Pakketten",
  "admin_pkg_subtitle": "Beheer de uitgelichte prijs pakketten die op de landingspagina worden getoond",
  "admin_pkg_seed": "Standaardwaarden",
  "admin_pkg_new": "Nieuw Pakket",
  "admin_pkg_create_title": "Nieuw Pakket Aanmaken",
  "admin_pkg_edit_title": "Pakket Bewerken",
  "admin_pkg_name": "Pakketnaam",
  "admin_pkg_tagline": "Slogan",
  "admin_pkg_description": "Beschrijving",
  "admin_pkg_price": "Prijs",
  "admin_pkg_currency": "Valuta",
  "admin_pkg_price_note": "Prijsopmerking",
  "admin_pkg_badge": "Badge",
  "admin_pkg_accent": "Accentkleur",
  "admin_pkg_cta_text": "CTA Knoptekst",
  "admin_pkg_cta_link": "CTA Link (optioneel)",
  "admin_pkg_sort": "Sorteervolgorde",
  "admin_pkg_features": "Kenmerken / Diensten Inbegrepen",
  "admin_pkg_add_feature": "Kenmerk Toevoegen",
  "admin_pkg_highlighted": "Uitgelicht",
  "admin_pkg_normal": "Normaal",
  "admin_pkg_create": "Pakket Aanmaken",
  "admin_pkg_save": "Wijzigingen Opslaan",
  "admin_pkg_saving": "Opslaan...",
  "admin_pkg_cancel": "Annuleren",
  "admin_pkg_empty_title": "Er zijn nog geen pakketten geconfigureerd",
  "admin_pkg_empty_desc": "Klik op Standaardwaarden om twee starterpakketten te genereren, of maak je eigen pakket.",
  "admin_pkg_features_label": "kenmerken",
  "admin_pkg_sort_label": "Sorteer",
  "admin_pkg_delete_confirm": "Dit pakket verwijderen? Het zal van de landingspagina worden verwijderd.",
  "admin_pkg_feature_placeholder": "Kenmerkomschrijving...",
  "admin_pkg_pricenote_placeholder": "bijv. Eenmalig / +5% omzetdeel",
  "admin_pkg_badge_placeholder": "bijv. BESTE WAARDE",
  "admin_pkg_loading": "Pakketten laden...",
  "pkg_qa_have_domain": "Ja, ik heb een domein",
  "pkg_qa_need_domain": "Ik heb een domein nodig",
  "pkg_qa_describe_biz": "Laat me mijn bedrijf beschrijven",
  "pkg_qa_more_info": "Vertel me meer over dit pakket",
  "sp_addon_title": "Add-ons & Ondersteuning",
  "sp_addon_desc": "Versterk uw project met prioritaire ondersteuning en expertadvies.",
  "sp_research_title": "Slimme Onderzoeksproducten",
  "sp_research_desc": "Marktintelligentie op aanvraag en slimme analysetools.",
  "tier_section_badge": "Slimme Pakketten",
  "tier_section_title": "Kies Uw",
  "tier_section_highlight": "Groeiplan",
  "tier_section_subtitle": "Gebundelde pakketten ontworpen voor maximale waarde. Kies het niveau dat bij u past.",
  "tier_one_time": "Eenmalig",
  "tier_monthly": "Maandelijks",
  "tier_section_footer": "Alle prijzen zijn exclusief BTW. Een aangepast pakket nodig? Chat met RisTA.",
  "tier_name_starter": "Starter",
  "tier_name_growth": "Growth",
  "tier_name_pro": "Pro",
  "tier_name_enterprise": "Enterprise",
  "tier_tag_starter": "Perfect om te beginnen met uw digitale aanwezigheid",
  "tier_tag_growth": "Schaal uw bedrijf met slimme tools",
  "tier_tag_pro": "Volledige digitale groei voor serieuze bedrijven",
  "tier_tag_enterprise": "Complete digitale transformatie",
  "tier_cta_starter": "Kies Starter",
  "tier_cta_growth": "Kies Growth",
  "tier_cta_pro": "Kies Pro",
  "tier_cta_enterprise": "Kies Enterprise",
  "tier_badge_popular": "POPULAIR",
  "tier_badge_best": "BESTE WAARDE",
  "tier_badge_all": "ALLES-IN-EEN",
  "tier_per_mo": "mnd",
  "tier_once_label": "eenmalig",
  "tier_or_monthly": "of",
  "tier_f_starter_1": "Slim businessplangenerator",
  "tier_f_starter_2": "Slimme CV-builder (3 stuks)",
  "tier_f_starter_3": "Website-audit en SEO-rapport",
  "tier_f_starter_4": "Slim logo- en merkpakket",
  "tier_f_starter_5": "Marktoverzichtrapport",
  "tier_f_starter_6": "FAQ-antwoordconcept",
  "tier_f_starter_7": "Blog-opzet vanuit trend",
  "tier_f_starter_8": "E-mailondersteuning binnen 48u",
  "tier_f_growth_1": "Alles van Starter",
  "tier_f_growth_2": "Slimme e-mailcampagne",
  "tier_f_growth_3": "Social media kalender & analyse (3 mnd)",
  "tier_f_growth_4": "Concurrentieanalyserapport",
  "tier_f_growth_5": "Advertentiegenerator (5 campagnes)",
  "tier_f_growth_6": "Outreach e-mailgenerator",
  "tier_f_growth_7": "Trendverklaarder",
  "tier_f_growth_8": "Positioneringsanalyse",
  "tier_f_growth_9": "Prioriteit e-mailondersteuning binnen 24u",
  "tier_f_pro_1": "Alles van Growth",
  "tier_f_pro_2": "SEO & digitale marketing setup",
  "tier_f_pro_3": "E-mailmarketing setup",
  "tier_f_pro_4": "Slimme videoscriptschrijver (5 stuks)",
  "tier_f_pro_5": "Snelle TAM-logicaschets",
  "tier_f_pro_6": "Risicochecklist",
  "tier_f_pro_7": "Functieprioritering",
  "tier_f_pro_8": "Leverancierslijstconcept",
  "tier_f_pro_9": "Slimme consultatiesessie (2u)",
  "tier_f_pro_10": "Prioriteitsondersteuning binnen 12u",
  "tier_f_ent_1": "Alles van Pro",
  "tier_f_ent_2": "Maatwerk softwareontwikkeling",
  "tier_f_ent_3": "Enterprise advertentiestrategie",
  "tier_f_ent_4": "Beheerd hosting (12 maanden)",
  "tier_f_ent_5": "Onderhoudsplan (6 maanden)",
  "tier_f_ent_6": "Slimme consultatie (10u)",
  "tier_f_ent_7": "Landingangscontrole",
  "tier_f_ent_8": "Executive summary voor slides",
  "tier_f_ent_9": "JTBD probleemstelling",
  "tier_f_ent_10": "Toegewijd accountmanager",
  "tier_f_ent_11": "Prioriteitswachtrij (4u respons)",
  "calc_title": "Prijscalculator",
  "calc_subtitle": "Vergelijk individuele diensten met pakketten om besparingen te zien.",
  "calc_badge": "Meer Besparen",
  "calc_select_services": "Selecteer Diensten",
  "calc_search_placeholder": "Zoek diensten...",
  "calc_selected": "geselecteerd",
  "calc_your_selection": "Uw Selectie",
  "calc_individual_total": "Individueel Totaal",
  "calc_best_tier": "Best Passend Pakket",
  "calc_you_save": "U Bespaart",
  "calc_no_services": "Selecteer diensten om besparingen te zien",
  "calc_clear_all": "Alles wissen",
  "calc_get_tier": "Dit Pakket Kiezen",
  "calc_individual_cheaper": "Individuele diensten zijn al voordelig. Voeg meer toe voor pakketkorting!",
  "referred_by": "Aanbevolen door",
  "referral_signup_reward": "Registreer om uw account te verbinden met deze verwijzing.",
  "badge_coming_soon": "Binnenkort beschikbaar",
  "badge_available_soon": "Binnenkort beschikbaar",
  "badge_from_price": "vanaf",
  "badge_preparing": "We bereiden deze dienst voor u voor",
  "svc_managed-hosting_label": "Beheerde hosting",
  "svc_managed-hosting_desc": "Volledig beheerde hosting met monitoring en ondersteuning",
  "svc_enterprise-advertising_label": "Bedrijfsreclame",
  "svc_enterprise-advertising_desc": "Grootschalige reclamecampagnes met gerichte strategie",
  "svc_email-marketing_label": "E-mailmarketing opzet",
  "svc_email-marketing_desc": "Professionele e-mailreeksen, sjablonen en automatisering",
  "svc_competitor-analysis_label": "Concurrentieanalyserapport",
  "svc_competitor-analysis_desc": "Marktintelligentie en concurrentiepositie",
  "svc_legal-docs_label": "Generator juridische documenten",
  "svc_legal-docs_desc": "NDA, contracten, sjablonen servicevoorwaarden",
  "svc_website-audit_label": "Website-audit en SEO-rapport",
  "svc_website-audit_desc": "Uitgebreide site-analyse met bruikbare aanbevelingen",
  "svc_trading-consultation_label": "Handelsconsultaties",
  "svc_trading-consultation_desc": "Door experts begeleide handelsstrategiesessies",
  "svc_managed-trading_label": "Beheerd handelen",
  "svc_managed-trading_desc": "Door experts beheerd handelen met bewezen strategieën",
  "svc_domain-management_label": "Domeinbeheer",
  "svc_domain-management_desc": "Domeinregistratie, DNS-beheer en overdrachten",
  "svc_personal-branding_label": "Persoonlijke branding",
  "svc_personal-branding_desc": "Bouw uw online aanwezigheid en persoonlijk merk",
  "admin_escalation_alert": "Chat-escalatie",
  "admin_view_escalations": "Bekijk escalatiewachtrij",
  "from": "Vanaf",
  "vector_gen_title": "Slimme vector",
  "vector_gen_title_hl": "Generator",
  "vector_gen_badge": "Slim vectorstudio",
  "vector_gen_desc": "Beschrijf je idee, upload referenties en ontvang binnen enkele seconden een productieklare SVG-vectorafbeelding.",
  "vector_gen_balance": "Je saldo",
  "vector_gen_per_gen": "credits per generatie",
  "vector_gen_prompt_label": "Beschrijf je vectorafbeelding",
  "vector_gen_prompt_ph": "bijv. Een minimalistisch berglogo met zonnestralen, in groenblauw en oranje kleuren...",
  "vector_gen_style": "Stijl",
  "vector_gen_color": "Kleurmodus",
  "vector_gen_refs": "Referentiebestanden",
  "vector_gen_optional": "optioneel, max. 3",
  "vector_gen_upload": "Upload referentie (PNG, JPG, SVG)",
  "vector_gen_generating": "Bezig met genereren...",
  "vector_gen_cta": "Vector genereren",
  "vector_gen_result": "Je vectorafbeelding",
  "vector_gen_model_used": "Model",
  "vector_gen_history": "Generatiegeschiedenis",
  "vector_gen_no_history": "Nog geen generaties",
  "vector_gen_login_req": "Log in om de vectorgenerator te gebruiken.",
  "vector_gen_service_title": "Professionele vectoren nodig?",
  "vector_gen_service_desc": "Bestel aangepaste vectorafbeeldingen als volledige designservice met revisies en merkrichtlijnen.",
  "vector_gen_service_cta": "Bekijk designservices",
  "vector_gen_product_type": "Producttype",
  "vector_gen_size": "Uitvoerformaat",
  "vector_gen_error_prompt": "Beschrijf alstublieft uw vectorafbeelding-idee.",
  "admin_vector_gen": "Vectorgenerator",
  "admin_showroom": "Showroom",
  "admin_landing_page": "Landingspagina",
  "admin_landing_text": "Landingspagina teksten",
  "admin_vector_title": "Vectorgenerator",
  "admin_vector_models": "Beschikbare modellen",
  "admin_vector_pricing": "Prijzen en limieten",
  "svc_vector-generator_label": "Slimme vectorgenerator",
  "svc_vector-generator_desc": "Genereer productieklare SVG-vectorafbeeldingen uit tekstbeschrijvingen",
  "sp_vector_gen_name": "Slimme vectorgenerator",
  "sp_vector_gen_desc": "Genereer SVG-vectorafbeeldingen uit tekstbeschrijvingen met slimme technologie.",
  "sp_vector_gen_feat": "Tekst-naar-vector generatie|SVG- en PNG-export|Meerdere stijlen|Inline SVG-editor|Referentie-upload|Prijs per credit",
  "sp_managed_hosting_name": "Beheerd hosting",
  "sp_managed_hosting_feat": "24/7 monitoring|Automatische updates|SSL-beheer|Dagelijkse backups|Prestatie-optimalisatie|Toegewijd support",
  "sp_enterprise_ad_name": "Enterprise-reclame",
  "sp_enterprise_ad_feat": "Campagnestrategie|Multi-channel|A/B-testen|Prestatie-tracking|Dedicated manager|Rapporten",
  "sp_email_marketing_name": "E-mailmarketing setup",
  "sp_email_marketing_feat": "E-mailsequenties|Template-ontwerp|Automatisering|Lijstbeheer|Analytics|A/B-testen",
  "sp_competitor_analysis_name": "Concurrentieanalyse-rapport",
  "sp_competitor_analysis_feat": "Marktanalyse|Concurrentenprofilering|SWOT|Prijsvergelijking|Aanbevelingen|Updates",
  "sp_website_audit_name": "Website-audit & SEO-rapport",
  "sp_website_audit_feat": "Technische audit|SEO-analyse|Prestatiemetrieken|Toegankelijkheid|Beveiligingsscan|Actieplan",
  "sp_defi_name": "DeFi-oplossingen",
  "sp_defi_feat": "Smart contracts|Yield farming|Liquiditeitspools|DeFi-audit|Token-creatie|Staking-oplossingen",
  "sp_personal_brand_name": "Persoonlijke branding",
  "sp_personal_brand_feat": "Merkstrategie|Social media-aanwezigheid|Persoonlijke website|Contentplanning|Professionele foto's|Bio schrijven",
  "sp_ad_gen_name": "Advertentie-generator",
  "sp_ad_gen_feat": "Advertentieteksten|Creatieve formaten|Multi-platform|A/B-varianten|Doelgroeptargeting|Prestatietips",
  "sp_priority_name": "Prioriteitswachtrij",
  "sp_priority_feat": "4 uur reactie|Toegewijd kanaal|Prioriteitsverwerking|Status-updates|SLA-garantie|Uitgebreide ondersteuning",
  "sp_maintenance_name": "Onderhoudsplan",
  "sp_maintenance_feat": "Maandelijkse updates|Beveiligingspatches|Prestatiemonitoring|Bugfixes|Uptime-garantie|Prioriteitsondersteuning",
  "sp_consulting_name": "Slim adviesgesprek",
  "sp_consulting_feat": "Expertconsultatie|Strategiesessie|Technisch advies|Implementatieplan|Follow-up notities|Opname inbegrepen",
  "sp_market_snapshot_name": "Marktoverzicht",
  "sp_market_snapshot_feat": "Marktoverzicht|Belangrijke trends|Concurrentielandschap|Groeikansen|Risicofactoren|Managementsamenvatting",
  "sp_trend_explainer_name": "Trend-uitlegger",
  "sp_trend_explainer_feat": "Trendanalyse|Branche-impact|Kansenbeoordeling|Tijdsprojectie|Actiestappen|Visueel rapport",
  "sp_competitor_qa_name": "Concurrentievragen",
  "sp_competitor_qa_feat": "Strategieanalyse|Prijsinzichten|Marktpositionering|Functievergelijking|Zwakteanalyse|Kansenkaart",
  "sp_country_entry_name": "Markttoetredingscheck",
  "sp_country_entry_feat": "Marktgereedheid|Regelgevingsoverzicht|Culturele factoren|Concurrentieanalyse|Toetredingsstrategie|Risicobeoordeling",
  "sp_vendor_shortlist_name": "Leverancierscorrectie",
  "sp_vendor_shortlist_feat": "Leveranciersonderzoek|Vergelijkingsmatrix|Prijsanalyse|Capaciteitsbeoordeling|Aanbevelingen|Contactgegevens",
  "sp_tam_logic_name": "TAM-logicaschets",
  "sp_tam_logic_feat": "TAM-schatting|SAM/SOM-uiteenzetting|Logisch raamwerk|Databronnen|Groeiaannames|Visuele presentatie",
  "sp_positioning_name": "Positioneringshoek",
  "sp_positioning_feat": "Marktpositionering|Doelgroepsegmentatie|Waardepropositie|Berichtenraamwerk|Differentiatie|Concurrentievoordeel",
  "sp_managed_trading_name": "Beheerd handelen",
  "sp_managed_trading_feat": "Portfoliobeheer|Risicobeheer|Bewezen strategieën|Regelmatige rapporten|Dedicated manager|Marktanalyse",
  "sp_trading_consult_name": "Handelsadvies",
  "sp_trading_consult_feat": "Individuele sessies|Strategie-ontwikkeling|Marktanalyse|Risicobeoordeling|Portfolio-review|Expertbegeleiding",
  "sp_domains_name": "LiveDomain-marktplaats",
  "sp_domains_feat": "Premium domeinen|Aftermarket-deals|Domeinwaardering|Transferondersteuning|Onderhandeling|Portfoliobeheer",
  "sp_domain_mgmt_name": "Domeinbeheer",
  "sp_domain_mgmt_feat": "DNS-beheer|Auto-verlenging|Transferondersteuning|Portfolio-tracking|SSL-certificaten|Whois-privacy",
  "sp_managed_hosting_desc": "Volledig beheerd hosting met monitoring, updates en toegewijd support.",
  "sp_enterprise_ad_desc": "Grootschalige reclamecampagnes met toegewijde strategie en beheer.",
  "sp_email_marketing_desc": "Professionele e-mailsequenties, templates en marketingautomatisering.",
  "sp_competitor_analysis_desc": "Diepgaande marktintelligentie en competitieve positioneringsanalyse.",
  "sp_website_audit_desc": "Uitgebreide site-analyse met uitvoerbare verbeteraanbevelingen.",
  "sp_managed_trading_desc": "Door experts beheerd handelen met bewezen strategieën en risicobeheer.",
  "sp_trading_consult_desc": "Individuele handelsstrategie-sessies begeleid door experts.",
  "sp_domains_desc": "Premium domeinacquisitie en aftermarket-deals.",
  "sp_domain_mgmt_desc": "DNS-beheer, verlengingen, overdrachten en domeinportfoliozorg.",
  "sp_defi_desc": "Smart contracts, yield farming en liquiditeitspool-oplossingen.",
  "sp_personal_brand_desc": "Bouw uw online aanwezigheid en persoonlijke merkidentiteit.",
  "sp_ad_gen_desc": "Genereer direct hoog-converterende advertentieteksten en creatives.",
  "sp_priority_desc": "Krijg een gegarandeerd antwoord binnen 4 uur.",
  "sp_maintenance_desc": "Doorlopend onderhoud, updates en technische ondersteuning.",
  "sp_consulting_desc": "Een-op-een advies met onze slimme technologie-experts.",
  "sp_market_snapshot_desc": "Snel overzicht van uw marktlandschap en trends.",
  "sp_trend_explainer_desc": "Begrijp opkomende trends die relevant zijn voor uw branche.",
  "sp_competitor_qa_desc": "Krijg antwoorden over de strategieën van uw concurrenten.",
  "sp_country_entry_desc": "Beoordeel de marktgereedheid voor internationale expansie.",
  "sp_vendor_shortlist_desc": "Samengestelde leverancierscorrectie voor uw specifieke behoeften.",
  "sp_tam_logic_desc": "Schatting van de totale adresseerbare markt met logische uiteenzetting.",
  "sp_positioning_desc": "Product + doelgroep positioneringsstrategieanalyse.",
  "vector_gen_model": "Model",
  "vector_gen_quality": "Kwaliteitsniveau",
  "svc_smart-resume_label": "Slimme CV-maker",
  "svc_smart-resume_desc": "ATS-geoptimaliseerde CV's door ons slimme systeem",
  "svc_smart-business-plan_label": "Slimme businessplan-generator",
  "svc_smart-business-plan_desc": "Volledig businessplan met financiën en marktanalyse",
  "svc_smart-seo-report_label": "Slim SEO-rapport",
  "svc_smart-seo-report_desc": "Geautomatiseerde site-analyse met bruikbare aanbevelingen",
  "svc_smart-brand-kit_label": "Slim logo en merk-kit",
  "svc_smart-brand-kit_desc": "Logo-concept, kleurenpalet, typografie en social media-assets",
  "svc_smart-email-campaign_label": "Slimme e-mailcampagne",
  "svc_smart-email-campaign_desc": "Intelligent e-mailmarketing met geoptimaliseerde sequenties",
  "svc_smart-social-calendar_label": "Social media-kalender & analyse",
  "svc_smart-social-calendar_desc": "30 dagen slim gegenereerde berichten met engagementstrategie",
  "svc_ad-generator_label": "Advertentie-generator",
  "svc_ad-generator_desc": "Genereer direct hoog-converterende advertentieteksten",
  "svc_smart-translation_label": "Slimme vertaaldiensten",
  "svc_smart-translation_desc": "Professionele documentvertaling in 50+ talen",
  "svc_smart-video-script_label": "Slimme videoscript-schrijver",
  "svc_smart-video-script_desc": "YouTube-, TikTok- en advertentiescripts geoptimaliseerd voor engagement",
  "svc_priority-queue_label": "Prioriteitswachtrij",
  "svc_priority-queue_desc": "Gegarandeerd antwoord binnen 4 uur",
  "svc_maintenance-plan_label": "Onderhoudsplan",
  "svc_maintenance-plan_desc": "Doorlopend onderhoud, updates en technische ondersteuning",
  "svc_smart-consulting_label": "Slim adviesgesprek",
  "svc_smart-consulting_desc": "Een-op-een advies met onze technologie-experts",
  "svc_market-snapshot_label": "Marktoverzicht",
  "svc_market-snapshot_desc": "Snel overzicht van uw marktlandschap",
  "svc_trend-explainer_label": "Trend-uitlegger",
  "svc_trend-explainer_desc": "Begrijp opkomende trends in uw branche",
  "svc_competitor-qa_label": "Concurrentievragen",
  "svc_competitor-qa_desc": "Antwoorden over strategieën van uw concurrenten",
  "svc_country-entry-check_label": "Markttoetredingscheck",
  "svc_country-entry-check_desc": "Beoordeel de marktgereedheid voor internationale expansie",
  "svc_should-i-care_label": "Relevantiecheck",
  "svc_should-i-care_desc": "Beoordeel of een trend belangrijk is voor uw bedrijf",
  "svc_report-matchmaker_label": "Rapport-zoeker",
  "svc_report-matchmaker_desc": "Vind het juiste onderzoeksrapport",
  "svc_which-region-first_label": "Regionale prioriteit",
  "svc_which-region-first_desc": "Datagestuurde begeleiding voor regionale marktintrede",
  "svc_vendor-shortlist_label": "Leverancierscorrectie",
  "svc_vendor-shortlist_desc": "Samengestelde leverancierslijst",
  "svc_forecast-explanation_label": "Prognose-uitleg",
  "svc_forecast-explanation_desc": "Duidelijke uitleg van marktprognoses",
  "svc_outreach-email-gen_label": "Outreach e-mailgenerator",
  "svc_outreach-email-gen_desc": "Genereer gepersonaliseerde outreach-e-mails op schaal",
  "svc_executive-summary_label": "Managementsamenvatting",
  "svc_executive-summary_desc": "Presentatieklare samenvattingen",
  "svc_faq-answer-draft_label": "FAQ-antwoord ontwerp",
  "svc_faq-answer-draft_desc": "Stel antwoorden op voor veelgestelde vragen",
  "svc_jtbd-problem_label": "JTBD-probleemstelling",
  "svc_jtbd-problem_desc": "Probleemanalyse met JTBD-framework",
  "svc_tam-logic-sketch_label": "TAM-logicaschets",
  "svc_tam-logic-sketch_desc": "Schatting totale markt met logische uiteenzetting",
  "svc_risk-checklist_label": "Risicochecklist",
  "svc_risk-checklist_desc": "Uitgebreide risicobeoordelingschecklist",
  "svc_feature-prioritization_label": "Feature-prioritering",
  "svc_feature-prioritization_desc": "Datagestuurde prioriteringsaanbevelingen",
  "svc_next-research-question_label": "Volgende onderzoeksvraag",
  "svc_next-research-question_desc": "Ontdek de volgende kritieke onderzoeksvraag",
  "svc_positioning-angle_label": "Positioneringshoek",
  "svc_positioning-angle_desc": "Product- en doelgroeppositioneringsanalyse",
  "svc_blog-outline-trend_label": "Blog-outline uit trend",
  "svc_blog-outline-trend_desc": "Transformeer trending onderwerpen in gestructureerde blog-outlines",
  "admin_ai_reports": "AI-servicerapporten",
  "admin_project_delivery": "Projectlevering",
  "admin_analytics_digest": "[TRANSLATE] Analytics Digest",
  "admin_seo_suggestions": "[TRANSLATE] SEO Optimization",
  "admin_visitor_map": "[TRANSLATE] Visitor Map",
  "admin_competitor_monitor": "[TRANSLATE] Competitor Intelligence",
  "admin_email_workflows": "[TRANSLATE] Email Workflows",
  "admin_collab_editing": "[TRANSLATE] Team Collaboration",
  "admin_status_online": "[TRANSLATE] Online",
  "admin_status_offline": "[TRANSLATE] Offline",
  "admin_status_online_desc": "[TRANSLATE] You are visible as online. Users requesting escalation will be connected to you.",
  "admin_status_offline_desc": "[TRANSLATE] You are offline. Users requesting escalation will see a message to try later.",
  "admin_ai_model": "[TRANSLATE] AI Model",
  "admin_prompts": "[TRANSLATE] Prompts",
  "admin_no_escalations": "[TRANSLATE] No escalations in queue.",
  "blog_edit": "[TRANSLATE] Edit Post",
  "admin_card_visibility": "[TRANSLATE] Card Visibility",
  "sp_managed_hosting": "[TRANSLATE] Managed Hosting",
  "sp_enterprise_ad": "[TRANSLATE] Enterprise Advertising",
  "sp_email_marketing": "[TRANSLATE] Email Marketing Setup",
  "sp_competitor_analysis": "[TRANSLATE] Competitor Analysis Report",
  "sp_website_audit": "[TRANSLATE] Website Audit & SEO Report",
  "sp_managed_trading": "[TRANSLATE] Managed Trading",
  "sp_trading_consult": "[TRANSLATE] Trading Consultations",
  "sp_domains": "[TRANSLATE] LiveDomain Aftermarket",
  "sp_domain_mgmt": "[TRANSLATE] Domain Management",
  "sp_defi": "[TRANSLATE] DeFi Solutions",
  "sp_personal_brand": "[TRANSLATE] Personal Branding",
  "sp_ad_gen": "[TRANSLATE] Ad Generator",
  "sp_priority": "[TRANSLATE] Priority Queue",
  "sp_maintenance": "[TRANSLATE] Maintenance Plan",
  "sp_consulting": "[TRANSLATE] Smart Consulting Session",
  "sp_market_snapshot": "[TRANSLATE] Market Snapshot",
  "sp_trend_explainer": "[TRANSLATE] Trend Explainer",
  "sp_competitor_qa": "[TRANSLATE] Competitor Q&A",
  "sp_country_entry": "[TRANSLATE] Country Entry Check",
  "sp_vendor_shortlist": "[TRANSLATE] Vendor Shortlist Draft",
  "sp_tam_logic": "[TRANSLATE] Quick TAM Logic Sketch",
  "sp_positioning": "[TRANSLATE] Positioning Angle",
  "agency_rista_tooltip": "Chat met RisTA",
  "agency_hero_title_1": "Razendsnelle websites die ",
  "agency_hero_title_highlight": "verkopen",
  "agency_hero_title_2": " voor lokale bedrijven",
  "agency_hero_subtitle_1": "Krijg een op maat gemaakte site die in milliseconden laadt + ingebouwde analytics voor",
  "agency_hero_subtitle_2": ". Geen trage pagina's, meer leads — lancering in weken.",
  "agency_hero_limited": "Beperkte plaatsen!",
  "agency_hero_cta_pricing": "Bekijk €498 pakket",
  "agency_hero_cta_audit": "Gratis audit",
  "agency_trust_maintenance": "onderhoud daarna",
  "agency_trust_efficient": "100% Efficiënt",
  "agency_trust_powered": "Aangedreven door Intelligent Systeem",
  "agency_speed_title": "Website laadsnelheid",
  "agency_speed_before": "Voor",
  "agency_speed_after": "Na",
  "agency_speed_leads": "+35% leads",
  "agency_pain_title_1": "Trage websites ",
  "agency_pain_title_2": "doden verkoop",
  "agency_pain_subtitle": "Elke seconde die uw site nodig heeft om te laden, verliest u klanten. Hier is het probleem — en hoe wij het oplossen.",
  "agency_pain_slow_title": "Traag laden = Verloren leads",
  "agency_pain_slow_desc": "Uw website heeft meer dan 5 seconden nodig om te laden. Bezoekers klikken weg voordat ze uw aanbod zien.",
  "agency_pain_stats_title": "47% vertrekt bij >3s",
  "agency_pain_stats_desc": "Google-onderzoek toont aan dat bijna de helft van de bezoekers een mobiele site verlaat die langer dan 3 seconden laadt.",
  "agency_pain_stats_source": "Bron: Google/SOASTA Research, 2017",
  "agency_pain_solution_title": "Onze Speed-First technologie",
  "agency_pain_solution_desc": "Op maat gemaakte sites geoptimaliseerd voor laden onder 1 seconde. Edge-cache, geoptimaliseerde afbeeldingen, geminimaliseerde code.",
  "agency_pricing_title": "Eenvoudige, transparante prijzen",
  "agency_pricing_subtitle": "Kies het plan dat bij uw bedrijf past. Alle plannen bevatten onze Speed-First technologie.",
  "agency_pricing_urgency_1": "Nog maar ",
  "agency_pricing_urgency_2": " starterplaatsen deze maand",
  "agency_pricing_popular": "MEEST POPULAIR",
  "agency_pricing_get_started": "Begin nu",
  "agency_pricing_guarantee": "30 dagen geld-terug-garantie",
  "agency_pricing_ideal": "Ideaal voor:",
  "agency_pricing_starter": "Starter",
  "agency_pricing_onetime": "eenmalig",
  "agency_pricing_starter_ideal": "Zelfstandigen",
  "agency_pricing_s_1": "Razendsnelle maatwerkwebsite",
  "agency_pricing_s_2": "Domein + hosting voor 1 jaar",
  "agency_pricing_s_3": "Basis analytics dashboard",
  "agency_pricing_s_4": "Mobiel-responsive design",
  "agency_pricing_s_5": "SSL-certificaat inbegrepen",
  "agency_pricing_performance": "Performance",
  "agency_pricing_perf_ideal": "Groeiende winkels",
  "agency_pricing_p_1": "Alles uit Starter",
  "agency_pricing_p_2": "E-commerce + winkelwagenherstel",
  "agency_pricing_p_3": "SEO-optimalisatiepakket",
  "agency_pricing_p_4": "A/B-test integratie",
  "agency_pricing_p_5": "Prioriteitsondersteuning",
  "agency_pricing_premium": "Premium",
  "agency_pricing_prem_ideal": "Opschalende bedrijven",
  "agency_pricing_pr_1": "Alles uit Performance",
  "agency_pricing_pr_2": "Google Ads beheer",
  "agency_pricing_pr_3": "Wekelijkse prestatie-audits",
  "agency_pricing_pr_4": "Toegewezen accountmanager",
  "agency_pricing_pr_5": "Aangepaste integraties",
  "agency_social_title": "Vertrouwd door lokale bedrijven",
  "agency_social_rista_label": "RisTA AI:",
  "agency_social_rista_quote": "Ik analyseer bezoekersgedrag in realtime om uw conversies te verhogen.",
  "agency_social_see_clients": "Wat onze klanten zeggen",
  "agency_social_t1_name": "Marko K.",
  "agency_social_t1_role": "CEO, Lokale winkel",
  "agency_social_t1_text": "Onze leads zijn verdubbeld in de eerste maand! De website laadt direct en onze klanten zijn dol op het nieuwe design.",
  "agency_social_t2_name": "Elena V.",
  "agency_social_t2_role": "Restauranteigenaar",
  "agency_social_t2_text": "Onze online bestellingen stegen met 40% na de lancering. Het snelheidsverschil is als dag en nacht.",
  "agency_social_t3_name": "Thomas H.",
  "agency_social_t3_role": "Fitnessstudio",
  "agency_social_t3_text": "Professioneel, snel en ze houden hun beloftes. Ons boekingspercentage steeg met 35% in slechts 3 weken.",
  "agency_social_t4_name": "Ana S.",
  "agency_social_t4_role": "Boutique-eigenaar",
  "agency_social_t4_text": "De e-commerce-setup was naadloos. Winkelwagenherstehl alleen al betaalde het Performance-plan terug in het eerste kwartaal.",
  "agency_social_metric_1": "Gem. laadtijd",
  "agency_social_metric_2": "Meer leads",
  "agency_social_metric_3": "Klanttevredenheid",
  "agency_services_title": "Alles wat uw bedrijf nodig heeft",
  "agency_services_subtitle": "Uitgebreide digitale oplossingen om uw online aanwezigheid te laten groeien.",
  "agency_svc_fast_title": "Snelle websites",
  "agency_svc_fast_desc": "Maatwerkwebsites die in minder dan 1 seconde laden. Mobile-first, SEO-geoptimaliseerd.",
  "agency_svc_ecom_title": "E-Commerce winkels",
  "agency_svc_ecom_desc": "Online verkopen met winkelwagenherstehl, betalingsverwerking en voorraadbeheer.",
  "agency_svc_seo_title": "SEO Audit & Optimalisatie",
  "agency_svc_seo_desc": "Hoger scoren in Google. Technische SEO, contentstrategie en maandelijkse rapporten.",
  "agency_svc_ads_title": "Google Ads instelling",
  "agency_svc_ads_desc": "Snel gericht verkeer krijgen. Campagne-instelling, optimalisatie en ROI-tracking inbegrepen.",
  "agency_svc_maint_title": "Onderhoud & Support",
  "agency_svc_maint_desc": "Hosting, beveiligingsupdates, back-ups en contentwijzigingen. Vanaf €30/maand.",
  "agency_faq_title": "Veelgestelde vragen",
  "agency_faq_q1": "Hoe snel laadt mijn website?",
  "agency_faq_a1": "Onder 1 seconde. We optimaliseren elke milliseconde — van serverrespons tot volledige visuele weergave.",
  "agency_faq_q2": "Wat is inbegrepen in het €498 Starterpakket?",
  "agency_faq_a2": "Een razendsnelle maatwerkwebsite, domein en hosting voor 1 jaar, basis analytics dashboard, responsive design en SSL-certificaat.",
  "agency_faq_q3": "Hoe lang duurt het om te lanceren?",
  "agency_faq_a3": "De meeste Starterprojecten lanceren in 2-3 weken. Performance- en Premiumplannen duren 4-6 weken.",
  "agency_faq_q4": "Bieden jullie doorlopend onderhoud aan?",
  "agency_faq_a4": "Ja. Na het eerste jaar begint onderhoud bij €30/maand, inclusief hosting, beveiligingsupdates en kleine contentwijzigingen.",
  "agency_faq_q5": "Kan ik mijn plan later upgraden?",
  "agency_faq_a5": "Absoluut. U kunt op elk moment upgraden van Starter naar Performance of Premium. We verrekenen uw initiële investering.",
  "agency_cta_title_1": "Klaar om te groeien ",
  "agency_cta_title_2": "zonder grenzen?",
  "agency_cta_subtitle": "Vertel ons over uw bedrijf en we maken een op maat gemaakt plan. Gratis consultatie, vrijblijvend.",
  "agency_contact_name": "Uw naam",
  "agency_contact_email": "E-mailadres",
  "agency_contact_biz_select": "Selecteer bedrijfstype",
  "agency_contact_biz_restaurant": "Restaurant / Horeca",
  "agency_contact_biz_retail": "Retail / Winkel",
  "agency_contact_biz_services": "Professionele diensten",
  "agency_contact_biz_fitness": "Fitness / Wellness",
  "agency_contact_biz_realestate": "Vastgoed",
  "agency_contact_biz_other": "Anders",
  "agency_contact_submit": "Gratis consultatie aanvragen",
  "agency_contact_sent_title": "Bericht verzonden!",
  "agency_contact_sent_desc": "We nemen binnen 24 uur contact met u op.",
  "agency_exit_title": "Wacht! Gratis snelheidsaudit?",
  "agency_exit_desc": "Ontdek hoeveel sneller uw website kan zijn. Gedetailleerd rapport — 100% gratis.",
  "agency_exit_email": "Uw email",
  "agency_exit_submit": "Audit versturen",
  "agency_exit_thanks_title": "Bedankt!",
  "agency_exit_thanks_desc": "We sturen uw gratis snelheidsaudit binnen 24 uur.",
  "agency_footer_brand_desc": "Ontwikkeld, gehost en ontworpen door Infinitybusiness.org",
  "agency_footer_services": "Diensten",
  "agency_footer_fast_web": "Snelle websites",
  "agency_footer_ecom": "E-Commerce winkels",
  "agency_footer_seo": "SEO Audit",
  "agency_footer_ads": "Google Ads instelling",
  "agency_footer_maint": "Onderhoud",
  "agency_footer_company": "Bedrijf",
  "agency_footer_about": "Over ons",
  "agency_footer_contact": "Contact",
  "agency_footer_privacy": "Privacybeleid",
  "agency_footer_terms": "Algemene voorwaarden",
  "agency_footer_touch": "Neem contact op",
  "agency_footer_copyright": "© 2026 Infinity Business. Alle rechten voorbehouden.",
  "agency_footer_dev_by": "Ontwikkeld, gehost en ontworpen door",
  "agency_footer_newsletter": "Abonneer op nieuwsbrief",
  "agency_footer_subscribe": "Abonneren",
  "agency_sticky_pricing": "Bekijk prijzen",
  "showroom_page_title": "Showroom",
  "showroom_meta_desc": "Ontdek ons portfolio van website-transformaties. Voor- en na-vergelijkingen van echte klantprojecten.",
  "showroom_badge": "Ons Werk",
  "showroom_title_prefix": "Project",
  "showroom_title_highlight": "Showroom",
  "showroom_subtitle": "Bekijk echte transformaties. Sleep de schuifregelaar om de voor- en na-staten van onze klantprojecten te vergelijken.",
  "showroom_search_placeholder": "Projecten zoeken...",
  "showroom_all_services": "Alle Diensten",
  "showroom_sort_newest": "Nieuwste eerst",
  "showroom_sort_oldest": "Oudste eerst",
  "showroom_sort_name_az": "Naam A-Z",
  "showroom_sort_name_za": "Naam Z-A",
  "showroom_active_filters": "Actieve filters",
  "showroom_showing": "Tonen",
  "showroom_project_singular": "project",
  "showroom_project_plural": "projecten",
  "showroom_empty": "Nog geen projecten in de showroom.",
  "showroom_no_match": "Geen projecten komen overeen met uw filters.",
  "showroom_features_built": "Gebouwde Functies",
  "showroom_visit_live": "Bezoek Live Site"
};
